<template>
  <form ref="form" class="ortic-form-horizontal">
    <o-card v-if="item" :capExceed="item.cap_exceeded ? true : false"
            :title="$t('sandoz.apo_one_contract') + ' // ' + (item.contract_no ? item.contract_no : '-')">
      <b-tabs class="inline-tabs">
        <b-tab :title="$t('sandoz.general')" active>

          <b-row>
            <b-col>
              <o-value-select v-model="item.user_id" :label="$t('sandoz.owner')"
                              :readonly="readonly" text-field="name"
                              url="/api/system/apo_one_users?sortBy=name"
                              value-field="id" @input-object="setCurrentUser"></o-value-select>

              <o-form-group :label="$t('sandoz.customer_external_id')" class="mb-2">
                <b-input-group>
                  <input v-model="item.customer_external_id" class="form-control" disabled type="text">
                  <b-input-group-append v-if="!readonly">
                    <b-btn variant="primary" @click.prevent="setMasterAddress">
                      <fa icon="ellipsis-h"/>
                    </b-btn>
                  </b-input-group-append>
                </b-input-group>
              </o-form-group>

              <o-value-select v-model="item.contract_year" :items="years" :label="$t('sandoz.contract_year')"
                              :readonly="readonly" :title="$t('sandoz.contract_year')"/>
              <o-datepicker v-model="item.contract_start" :errorField="'contract_start'"
                            :label="$t('sandoz.contract_start')" :disabled="readonly"
                            :typeable="true"/>
              <o-datepicker v-model="item.contract_expiration" :errorField="'contract_expiration'"
                            :label="$t('sandoz.contract_expiration')" :typeable="true" :disabled="readonly"
                            class="d-none"/>
              <o-form-group :label="$t('sandoz.previous_contract')" class="mb-2 d-none">
                <b-input-group>
                  <input :value="item.previous && item.previous.contract_no ? item.previous.contract_no : null"
                         class="form-control" disabled type="text">
                  <b-input-group-append>
                    <b-btn variant="primary" @click.prevent="$refs.addPreviousContractModel.show()">
                      <fa icon="ellipsis-h"/>
                    </b-btn>
                  </b-input-group-append>
                  <input v-model="item.previous_contract" type="hidden">
                </b-input-group>
              </o-form-group>
            </b-col>
            <b-col>
              <o-value-select v-model="item.language" :items="languages" :label="$t('sandoz.language')"
                              :readonly="checkLangSelection(item) ? 'readonly' : null"/>

              <template v-if="user.is_super_user">
                <o-textarea v-model="item.super_user_comment" :label="$t('sandoz.super_user_comment')" class="mt-3"
                            :error-field="'super_user_comment'"
                            :class="isCommentError && !item.super_user_comment ? 'has-error' : ''"></o-textarea>
              </template>
            </b-col>
          </b-row>
        </b-tab>
        <b-tab :title="$t('sandoz.items')">
          <b-overlay :show="item.type == null">
            <div class="card mb-2">
              <div class="d-flex card-body card-silver p-2">
                <table>
                  <tbody>
                  <tr>
                    <td>{{ $t('sandoz.marketing_activity_total_selected') }}</td>
                    <td class="text-right">{{ item.marketing_activities | formatNumber}}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <template v-for="(address, index) in item.addresses">
              <template v-if="address.address_type === 'master'">
                <div class="d-flex">
                  <div class="pt-2">
                    <b>
                      {{ address.company_name ?  address.company_name + ', ' : '' }}
                      {{ address.street ? address.street + ', ' : '' }}
                      {{ address.zip }} {{ address.city }}
                    </b>
                    <b-badge v-if="address.cap_exceeded" pill href="#"  class="ml-2" variant="danger">{{$t('sandoz.cap_exceeded')}}</b-badge>
                  </div>
                </div>
                <div class="table-responsive mt-3 ml-2 ice-item-table-div">
                  <table class="table table-sm ice-item-table">
                    <thead>
                    <tr>
                      <th scope="col" class=""></th>
                      <th scope="col" class="mw-400">{{ $t('sandoz.item') }}</th>
                      <th scope="col">{{ $t('sandoz.item_price') }}</th>
                      <th scope="col">{{ $t('sandoz.price') }}</th>
                      <th scope="col">{{ $t('sandoz.quantity') }}</th>
                      <th scope="col">{{ $t('sandoz.exists') }}</th>
                      <th scope="col">{{ $t('sandoz.qty_1') }}</th>
                      <th scope="col">{{ $t('sandoz.qty_2') }}</th>
                      <th scope="col">{{ $t('sandoz.qty_3') }}</th>
                      <th scope="col">{{ $t('sandoz.qty_4') }}</th>
                      <th scope="col">{{ $t('core.january_short') }}</th>
                      <th scope="col">{{ $t('core.february_short') }}</th>
                      <th scope="col">{{ $t('core.march_short') }}</th>
                      <th scope="col">{{ $t('core.april_short') }}</th>
                      <th scope="col">{{ $t('core.may_short') }}</th>
                      <th scope="col">{{ $t('core.june_short') }}</th>
                      <th scope="col">{{ $t('core.july_short') }}</th>
                      <th scope="col">{{ $t('core.august_short') }}</th>
                      <th scope="col">{{ $t('core.september_short') }}</th>
                      <th scope="col">{{ $t('core.october_short') }}</th>
                      <th scope="col">{{ $t('core.november_short') }}</th>
                      <th scope="col">{{ $t('core.december_short') }}</th>
                      <th scope="col" class="d-none">{{ $t('sandoz.from') }}</th>
                      <th scope="col" class="d-none">{{ $t('sandoz.to') }}</th>
                    </tr>
                    </thead>
                    <tbody v-if="address.items && Object.keys(address.items).length">
                    <template v-for="(line, lineIndex) in address.items">
                      <tr class="master-item">
                        <td>
                          <div class="item-accordion cursor-pointer"
                               v-if="checkLineChildren(line)">
                            <fa icon="plus" @click="toggleAccordion(index, lineIndex)"
                                v-if="getAccordion(index, lineIndex) === -1"/>
                            <fa icon="minus" @click="toggleAccordion(index, lineIndex)"
                                v-if="getAccordion(index, lineIndex) !== -1"/>
                          </div>
                        </td>
                        <td>
                          <div v-if="!line.allow_product_name_to_change"> {{ line.product ? line.product.name : line.product_name }}
                            <router-link v-if="user && user.is_super_user && line.product && line.product.product_master_id" target="_blank"
                                         :to="{ path: '/sandoz/product_masters/' + line.product.product_master_id }">
                              <fa icon="pencil-alt"/>
                            </router-link>
                            <a :href="linkValidate(line.product.info_link)" target="_blank" v-if="line.product && line.product.info_link">
                              <fa icon="file"/>
                            </a>
                          </div>
                          <div v-else>
                            <o-input-control type="text" v-model="line.product_name" class="full-width"> </o-input-control>
                            <router-link v-if="user && user.is_super_user && line.product && line.product.product_master_id" target="_blank"
                                         :to="{ path: '/sandoz/product_masters/' + line.product.product_master_id }">
                              <fa icon="pencil-alt"/>
                            </router-link>
                            <a :href="linkValidate(line.product.info_link)" target="_blank" v-if="line.product && line.product.info_link">
                              <fa icon="file"/>
                            </a>
                          </div>
                        </td>
                        <td class="item-price">{{ line.item_price | formatPrice }}</td>
                        <td>
                          <template v-if="line.price_changes && line.price_changes.price_changes === 'no_changes_allowed'">
                            <div class="w-100">
                              <div class="form-control text-right" readonly="readonly">{{line.price | formatPrice}}</div>
                            </div>
                          </template>
                          <template v-else>
                            <o-input-control :ignore-range="true" :step="1" type="number" v-model="line.price"
                                             @blur="validatePrice(line, index)" class="form-price"></o-input-control>
                          </template>
                        </td>
                        <td>
                          <template v-if="isReadonly(line, 'yearly')">
                            <div class="w-100 form-qty" v-if="line.delivery.yearly">
                              <div class="form-control" readonly="readonly">{{line.delivery.yearly.quantity}}</div>
                            </div>
                          </template>
                          <template v-else>
                            <template v-if="line.product_master_values && Object.keys(line.product_master_values).length">
                              <o-value-select v-model="line.delivery.yearly.quantity"
                                class="fixed-value-dropdown"
                                text-field="value"
                                :items="line.product_master_values"
                                value-field="value"
                                @previous-value="setPreviousQuantity($event, line, 'yearly')"
                                @change.native="setPrice(line, index, 'yearly'), setQuantityToChild(line, 'q1', index)">
                              </o-value-select>
                            </template>
                            <template v-else>
                              <o-input-control :ignore-range="true" :step="1" type="number" v-model="line.delivery.yearly.quantity"
                                              @previous-value="setPreviousQuantity($event, line, 'yearly')"
                                              @blur="setPrice(line, index, 'yearly'), setQuantityToChild(line, 'q1', index)"
                                              class="form-qty">
                              </o-input-control>
                            </template>
                          </template>
                        </td>
                        <td :class="line && determErrorID.includes(address.id+'-'+line.product.id) ? 'exist_error': ''">
                          <template
                            v-if="line && (line.delivery.yearly.quantity > 0 || line.delivery.q1.quantity > 0 || line.delivery.q2.quantity > 0 || line.delivery.q3.quantity > 0 || line.delivery.q4.quantity > 0  || line.delivery.jan || line.delivery.jan || line.delivery.feb || line.delivery.mar || line.delivery.apr || line.delivery.may || line.delivery.jun || line.delivery.jul || line.delivery.aug || line.delivery.sep || line.delivery.oct || line.delivery.nov || line.delivery.dec)">
                            <template v-if="line.attribute_required || line.exist_value !== null">
                              <b-form-checkbox v-model="line.contract_line_exist_attribute"
                                               :disabled="readonly || line.exist_value !== null"
                                               :indeterminate="line.exist_value === null && !!line.indeterminate">
                              </b-form-checkbox>
                            </template>
                          </template>
                        </td>
                        <td>
                          <template v-if="isReadonly(line, 'q1')">
                            <div class="w-100 form-qty" v-if="line.delivery.q1">
                              <div class="form-control" readonly="readonly">{{line.delivery.q1.quantity}}</div>
                            </div>
                          </template>
                          <template v-else>
                            <o-input-control :ignore-range="true" :step="1" type="number" v-model="line.delivery.q1.quantity"
                                             @previous-value="setPreviousQuantity($event, line, 'q1')"
                                             @blur="setPrice(line, index, 'q1'), setQuantityToChild(line, 'q1', index)"
                                             class="form-qty">
                            </o-input-control>
                          </template>
                        </td>
                        <td>
                          <template v-if="isReadonly(line, 'q2')">
                            <div class="w-100 form-qty" v-if="line.delivery.q2">
                              <div class="form-control" readonly="readonly">{{line.delivery.q2.quantity}}</div>
                            </div>
                          </template>
                          <template v-else>
                            <o-input-control :ignore-range="true" :step="1" type="number" v-model="line.delivery.q2.quantity"
                                             @previous-value="setPreviousQuantity($event, line, 'q2')"
                                             @blur="setPrice(line, index, 'q2'), setQuantityToChild(line, 'q2', index)"
                                             class="form-qty">
                            </o-input-control>
                          </template>
                        </td>
                        <td>
                          <template v-if="isReadonly(line, 'q3')">
                            <div class="w-100 form-qty" v-if="line.delivery.q3">
                              <div class="form-control" readonly="readonly">{{line.delivery.q3.quantity}}</div>
                            </div>
                          </template>
                          <template v-else>
                            <o-input-control :ignore-range="true" :step="1" type="number" v-model="line.delivery.q3.quantity"
                                             @previous-value="setPreviousQuantity($event, line, 'q3')"
                                             @blur="setPrice(line, index, 'q3'), setQuantityToChild(line, 'q3', index)"
                                             class="form-qty">
                            </o-input-control>
                          </template>
                        </td>
                        <td>
                          <template v-if="isReadonly(line, 'q4')">
                            <div class="w-100 form-qty" v-if="line.delivery.q4">
                              <div class="form-control" readonly="readonly">{{line.delivery.q4.quantity}}</div>
                            </div>
                          </template>
                          <template v-else>
                            <o-input-control :ignore-range="true" :step="1" type="number" v-model="line.delivery.q4.quantity"
                                             @previous-value="setPreviousQuantity($event, line, 'q4')"
                                             @blur="setPrice(line, index, 'q4'), setQuantityToChild(line, 'q4', index)"
                                             class="form-qty">
                            </o-input-control>
                          </template>
                        </td>
                        <td>
                          <template v-if="isReadonly(line, 'jan')">
                            <div class="w-100 form-qty" v-if="line.delivery.jan">
                              <div class="form-control" readonly="readonly">{{line.delivery.jan.quantity}}</div>
                            </div>
                          </template>
                          <template v-else-if="line.delivery && line.delivery.jan">
                            <o-input-control :ignore-range="true" :step="1" type="number" v-model="line.delivery.jan.quantity"
                                             @previous-value="setPreviousQuantity($event, line, 'jan')"
                                             @blur="setPrice(line, index, 'jan'), setQuantityToChild(line, 'jan', index)"
                                             class="form-qty">
                            </o-input-control>
                          </template>
                        </td>
                        <td>
                          <template v-if="isReadonly(line, 'feb')">
                            <div class="w-100 form-qty" v-if="line.delivery.feb">
                              <div class="form-control" readonly="readonly">{{line.delivery.feb.quantity}}</div>
                            </div>
                          </template>
                          <template v-else-if="line.delivery && line.delivery.feb">
                            <o-input-control :ignore-range="true" :step="1" type="number" v-model="line.delivery.feb.quantity"
                                             @previous-value="setPreviousQuantity($event, line, 'feb')"
                                             @blur="setPrice(line, index, 'feb'), setQuantityToChild(line, 'feb', index)"
                                             class="form-qty">
                            </o-input-control>
                          </template>
                        </td>
                        <td>
                          <template v-if="isReadonly(line, 'mar')">
                            <div class="w-100 form-qty" v-if="line.delivery.mar">
                              <div class="form-control" readonly="readonly">{{line.delivery.mar.quantity}}</div>
                            </div>
                          </template>
                          <template v-else-if="line.delivery && line.delivery.mar">
                            <o-input-control :ignore-range="true" :step="1" type="number" v-model="line.delivery.mar.quantity"
                                             @previous-value="setPreviousQuantity($event, line, 'mar')"
                                             @blur="setPrice(line, index, 'mar'), setQuantityToChild(line, 'mar', index)"
                                             class="form-qty">
                            </o-input-control>
                          </template>
                        </td>
                        <td>
                          <template v-if="isReadonly(line, 'apr')">
                            <div class="w-100 form-qty" v-if="line.delivery.apr">
                              <div class="form-control" readonly="readonly">{{line.delivery.apr.quantity}}</div>
                            </div>
                          </template>
                          <template v-else-if="line.delivery && line.delivery.apr">
                            <o-input-control :ignore-range="true" :step="1" type="number" v-model="line.delivery.apr.quantity"
                                             @previous-value="setPreviousQuantity($event, line, 'apr')"
                                             @blur="setPrice(line, index, 'apr'), setQuantityToChild(line, 'apr', index)"
                                             class="form-qty">
                            </o-input-control>
                          </template>
                        </td>
                        <td>
                          <template v-if="isReadonly(line, 'may')">
                            <div class="w-100 form-qty" v-if="line.delivery.may">
                              <div class="form-control" readonly="readonly">{{line.delivery.may.quantity}}</div>
                            </div>
                          </template>
                          <template v-else-if="line.delivery && line.delivery.may">
                            <o-input-control :ignore-range="true" :step="1" type="number" v-model="line.delivery.may.quantity"
                                             @previous-value="setPreviousQuantity($event, line, 'may')"
                                             @blur="setPrice(line, index, 'may'), setQuantityToChild(line, 'may', index)"
                                             class="form-qty">
                            </o-input-control>
                          </template>
                        </td>
                        <td>
                          <template v-if="isReadonly(line, 'jun')">
                            <div class="w-100 form-qty" v-if="line.delivery.jun">
                              <div class="form-control" readonly="readonly">{{line.delivery.jun.quantity}}</div>
                            </div>
                          </template>
                          <template v-else-if="line.delivery && line.delivery.jun">
                            <o-input-control :ignore-range="true" :step="1" type="number" v-model="line.delivery.jun.quantity"
                                             @previous-value="setPreviousQuantity($event, line, 'jun')"
                                             @blur="setPrice(line, index, 'jun'), setQuantityToChild(line, 'jun', index)"
                                             class="form-qty">
                            </o-input-control>
                          </template>
                        </td>
                        <td>
                          <template v-if="isReadonly(line, 'jul')">
                            <div class="w-100 form-qty" v-if="line.delivery.jul">
                              <div class="form-control" readonly="readonly">{{line.delivery.jul.quantity}}</div>
                            </div>
                          </template>
                          <template v-else-if="line.delivery && line.delivery.jul">
                            <o-input-control :ignore-range="true" :step="1" type="number" v-model="line.delivery.jul.quantity"
                                             @previous-value="setPreviousQuantity($event, line, 'jul')"
                                             @blur="setPrice(line, index, 'jul'), setQuantityToChild(line, 'jul', index)"
                                             class="form-qty">
                            </o-input-control>
                          </template>
                        </td>
                        <td>
                          <template v-if="isReadonly(line, 'aug')">
                            <div class="w-100 form-qty" v-if="line.delivery.aug">
                              <div class="form-control" readonly="readonly">{{line.delivery.aug.quantity}}</div>
                            </div>
                          </template>
                          <template v-else-if="line.delivery && line.delivery.aug">
                            <o-input-control :ignore-range="true" :step="1" type="number" v-model="line.delivery.aug.quantity"
                                             @previous-value="setPreviousQuantity($event, line, 'aug')"
                                             @blur="setPrice(line, index, 'aug'), setQuantityToChild(line, 'aug', index)"
                                             class="form-qty">
                            </o-input-control>
                          </template>
                        </td>
                        <td>
                          <template v-if="isReadonly(line, 'sep')">
                            <div class="w-100 form-qty" v-if="line.delivery.sep">
                              <div class="form-control" readonly="readonly">{{line.delivery.sep.quantity}}</div>
                            </div>
                          </template>
                          <template v-else-if="line.delivery && line.delivery.sep">
                            <o-input-control :ignore-range="true" :step="1" type="number" v-model="line.delivery.sep.quantity"
                                             @previous-value="setPreviousQuantity($event, line, 'sep')"
                                             @blur="setPrice(line, index, 'sep'), setQuantityToChild(line, 'sep', index)"
                                             class="form-qty">
                            </o-input-control>
                          </template>
                        </td>
                        <td>
                          <template v-if="isReadonly(line, 'oct')">
                            <div class="w-100 form-qty" v-if="line.delivery.oct">
                              <div class="form-control" readonly="readonly">{{line.delivery.oct.quantity}}</div>
                            </div>
                          </template>
                          <template v-else-if="line.delivery && line.delivery.oct">
                            <o-input-control :ignore-range="true" :step="1" type="number" v-model="line.delivery.oct.quantity"
                                             @previous-value="setPreviousQuantity($event, line, 'oct')"
                                             @blur="setPrice(line, index, 'oct'), setQuantityToChild(line, 'oct', index)"
                                             class="form-qty">
                            </o-input-control>
                          </template>
                        </td>
                        <td>
                          <template v-if="isReadonly(line, 'nov')">
                            <div class="w-100 form-qty" v-if="line.delivery.nov">
                              <div class="form-control" readonly="readonly">{{line.delivery.nov.quantity}}</div>
                            </div>
                          </template>
                          <template v-else-if="line.delivery && line.delivery.nov">
                            <o-input-control :ignore-range="true" :step="1" type="number" v-model="line.delivery.nov.quantity"
                                             @previous-value="setPreviousQuantity($event, line, 'nov')"
                                             @blur="setPrice(line, index, 'nov'), setQuantityToChild(line, 'nov', index)"
                                             class="form-qty">
                            </o-input-control>
                          </template>
                        </td>
                        <td>
                          <template v-if="isReadonly(line, 'dec')">
                            <div class="w-100 form-qty" v-if="line.delivery.dec">
                              <div class="form-control" readonly="readonly">{{line.delivery.dec.quantity}}</div>
                            </div>
                          </template>
                          <template v-else-if="line.delivery && line.delivery.dec">
                            <o-input-control :ignore-range="true" :step="1" type="number" v-model="line.delivery.dec.quantity"
                                             @previous-value="setPreviousQuantity($event, line, 'dec')"
                                             @blur="setPrice(line, index, 'dec'), setQuantityToChild(line, 'dec', index)"
                                             class="form-qty">
                            </o-input-control>
                          </template>
                        </td>
                        <td class="d-none">
                          <o-value-select-control v-model="line.valid_from_month" :items="months"
                                                  :readonly="!line.allow_manual_date_entry"
                                                  @change.native="setDateToChildren(line, index), setDateChanged(line, 'from')">
                          </o-value-select-control>
                        </td>
                        <td class="d-none">
                          <o-value-select-control v-model="line.valid_to_month" :items="months"
                                                  :readonly="!line.allow_manual_date_entry"
                                                  @change.native="setDateToChildren(line, index, 'to'), setDateChanged(line, 'to')">
                          </o-value-select-control>
                        </td>
                      </tr>
                      <template v-if="line.children && Object.keys(line.children).length">
                        <template v-for="(subLine, subLineIndex) in line.children">
                          <tr :class="{'d-none': (getAccordion(index, lineIndex) === -1)}">
                            <td>
                              <div class="item-accordion cursor-pointer sub-accordion-icon"
                                  v-if="checkLineChildren(subLine)">
                                <fa icon="plus" @click="toggleAccordion(lineIndex, subLineIndex)"
                                    v-if="getAccordion(lineIndex, subLineIndex) === -1"/>
                                <fa icon="minus" @click="toggleAccordion(lineIndex, subLineIndex)"
                                    v-if="getAccordion(lineIndex, subLineIndex) !== -1"/>
                              </div>
                            </td>
                            <td class="indention" v-if="!subLine.allow_product_name_to_change">{{ subLine.product ? subLine.product.name : subLine.product_name }}
                              <router-link v-if="user && user.is_super_user && subLine.product && subLine.product.product_master_id" target="_blank"
                                           :to="{ path: '/sandoz/product_masters/' + subLine.product.product_master_id }">
                                <fa icon="pencil-alt"/>
                              </router-link>
                              <a :href="linkValidate(subLine.product.info_link)" target="_blank" v-if="subLine.product && subLine.product.info_link">
                                <fa icon="file"/>
                              </a>
                            </td>
                            <td class="indention" v-else>
                              <o-input-control type="text" v-model="subLine.product_name" class="full-width"> </o-input-control>
                              <router-link v-if="user && user.is_super_user && subLine.product && subLine.product.product_master_id" target="_blank"
                                           :to="{ path: '/sandoz/product_masters/' + subLine.product.product_master_id }">
                                <fa icon="pencil-alt"/>
                              </router-link>
                              <a :href="linkValidate(subLine.product.info_link)" target="_blank" v-if="subLine.product && subLine.product.info_link">
                                <fa icon="file"/>
                              </a>
                            </td>
                            <td class="item-price">{{ subLine.item_price | formatPrice }}</td>
                            <td>
                              <template v-if="subLine.price_changes && subLine.price_changes.price_changes === 'no_changes_allowed'">
                                <div class="w-100">
                                  <div class="form-control text-right" readonly="readonly">{{subLine.price | formatPrice}}</div>
                                </div>
                              </template>
                              <template v-else>
                                <o-input-control :min="1" type="number" v-model="subLine.price"
                                                 @blur="validatePrice(subLine, index)" class="form-price"></o-input-control>
                              </template>
                            </td>
                            <td>
                              <template v-if="isReadonly(subLine, 'yearly')">
                                <div class="w-100 form-qty" v-if="subLine.delivery.yearly">
                                  <div class="form-control" readonly="readonly">{{subLine.delivery.yearly.quantity}}</div>
                                </div>
                              </template>
                              <template v-else>
                                <template v-if="subLine.product_master_values && Object.keys(subLine.product_master_values).length">
                                  <o-value-select v-model="subLine.delivery.yearly.quantity"
                                    class="fixed-value-dropdown"
                                    text-field="value"
                                    :items="subLine.product_master_values"
                                    value-field="value"
                                    @previous-value="setPreviousQuantity($event, subLine, 'yearly')"
                                    @change.native="setQuantityToParent(line, subLine, 'yearly', index),
                                    setQuantityToChild(subLine, 'yearly', subLineIndex),
                                    setBoxQuantity(line, 'yearly', subLine.box_or_gadget, index)">
                                  </o-value-select>
                                </template>
                                <template v-else>
                                  <o-input-control :ignore-range="true" :step="1" type="number" v-model="subLine.delivery.yearly.quantity"
                                                   @previous-value="setPreviousQuantity($event, subLine, 'yearly')"
                                                   @blur="setQuantityToParent(line, subLine, 'yearly', index),
                                                  setQuantityToChild(subLine, 'yearly', subLineIndex),
                                                  setBoxQuantity(line, 'yearly', subLine.box_or_gadget, index)"
                                                  class="form-qty">
                                  </o-input-control>
                                </template>
                              </template>
                            </td>
                            <td :class="determErrorID.includes(address.id+'-'+subLine.product.id) ? 'exist_error': ''">
                              <template
                                v-if="subLine.delivery.yearly.quantity > 0 || subLine.delivery.q1.quantity > 0 || subLine.delivery.q2.quantity > 0 || subLine.delivery.q3.quantity > 0 || subLine.delivery.q4.quantity > 0 || subLine.delivery.jan || subLine.delivery.jan || subLine.delivery.feb || subLine.delivery.mar || subLine.delivery.apr || subLine.delivery.may || subLine.delivery.jun || subLine.delivery.jul || subLine.delivery.aug || subLine.delivery.sep || subLine.delivery.oct || subLine.delivery.nov || subLine.delivery.dec">
                                <template v-if="subLine.attribute_required || subLine.exist_value !== null">
                                  <b-form-checkbox v-model="subLine.contract_line_exist_attribute"
                                                   :disabled="readonly || subLine.exist_value !== null"
                                                   :indeterminate="subLine.exist_value === null && !!subLine.indeterminate">
                                  </b-form-checkbox>
                                </template>
                              </template>
                            </td>
                            <td>
                              <template v-if="isReadonly(subLine, 'q1', true)">
                                <div class="w-100 form-qty" v-if="subLine.delivery.q1">
                                  <div class="form-control" readonly="readonly" :class="subLine.sync_quarter_q1 ? 'sync_quarter' : ''">{{subLine.delivery.q1.quantity}}</div>
                                </div>
                              </template>
                              <template v-else>
                                <o-input-control :ignore-range="true" :step="1" type="number" v-model="subLine.delivery.q1.quantity"
                                                 @previous-value="setPreviousQuantity($event, subLine, 'q1')"
                                                 @blur="setQuantityToParent(line, subLine, 'q1', index),
                                                 setQuantityToChild(subLine, 'q1', subLineIndex),
                                                 setBoxQuantity(line, 'q1', subLine.box_or_gadget, index)"
                                                 class="form-qty">
                                </o-input-control>
                              </template>
                            </td>
                            <td>
                              <template v-if="isReadonly(subLine, 'q2', true)">
                                <div class="w-100 form-qty" v-if="subLine.delivery.q2">
                                  <div class="form-control" readonly="readonly" :class="subLine.sync_quarter_q2 ? 'sync_quarter' : ''">{{subLine.delivery.q2.quantity}}</div>
                                </div>
                              </template>
                              <template v-else>
                                <o-input-control :ignore-range="true" :step="1" type="number" v-model="subLine.delivery.q2.quantity"
                                                 @previous-value="setPreviousQuantity($event, subLine, 'q2')"
                                                 @blur="setQuantityToParent(line, subLine, 'q2', index),
                                                 setQuantityToChild(subLine, 'q2', subLineIndex),
                                                 setBoxQuantity(line, 'q2', subLine.box_or_gadget, index)"
                                                 class="form-qty">
                                </o-input-control>
                              </template>
                            </td>
                            <td>
                              <template v-if="isReadonly(subLine, 'q3', true)">
                                <div class="w-100 form-qty" v-if="subLine.delivery.q3">
                                  <div class="form-control" readonly="readonly" :class="subLine.sync_quarter_q3 ? 'sync_quarter' : ''">{{subLine.delivery.q3.quantity}}</div>
                                </div>
                              </template>
                              <template v-else>
                                <o-input-control :ignore-range="true" :step="1" type="number" v-model="subLine.delivery.q3.quantity"
                                                 @previous-value="setPreviousQuantity($event, subLine, 'q3')"
                                                 @blur="setQuantityToParent(line, subLine, 'q3', index),
                                                 setQuantityToChild(subLine, 'q3', subLineIndex),
                                                 setBoxQuantity(line, 'q3', subLine.box_or_gadget, index)"
                                                 class="form-qty">
                                </o-input-control>
                              </template>
                            </td>
                            <td>
                              <template v-if="isReadonly(subLine, 'q4', true)">
                                <div class="w-100 form-qty" v-if="subLine.delivery.q4">
                                  <div class="form-control form-qty" readonly="readonly" :class="subLine.sync_quarter_q4 ? 'sync_quarter' : ''">{{subLine.delivery.q4.quantity}}</div>
                                </div>
                              </template>
                              <template v-else>
                                <o-input-control :ignore-range="true" :step="1" type="number" v-model="subLine.delivery.q4.quantity"
                                                 @previous-value="setPreviousQuantity($event, subLine, 'q4')"
                                                 @blur="setQuantityToParent(line, subLine, 'q4', index),
                                                 setQuantityToChild(subLine, 'q4', subLineIndex),
                                                 setBoxQuantity(line, 'q4', subLine.box_or_gadget, index)"
                                                 class="form-qty">
                                </o-input-control>
                              </template>
                            </td>
                            <td>
                              <template v-if="isReadonly(subLine, 'jan')">
                                <div class="w-100 form-qty" v-if="subLine.delivery.jan">
                                  <div class="form-control" readonly="readonly">{{line.delivery.jan.quantity}}</div>
                                </div>
                              </template>
                              <template v-else-if="subLine.delivery && subLine.delivery.jan">
                                <o-input-control :ignore-range="true" :step="1" type="number" v-model="subLine.delivery.jan.quantity"
                                                 @previous-value="setPreviousQuantity($event, subLine, 'jan')"
                                                 @blur="setPrice(subLine, index, 'jan'), setQuantityToChild(subLine, 'jan', subLineIndex)"
                                                 class="form-qty">
                                </o-input-control>
                              </template>
                            </td>
                            <td>
                              <template v-if="isReadonly(subLine, 'feb')">
                                <div class="w-100 form-qty" v-if="subLine.delivery.feb">
                                  <div class="form-control" readonly="readonly">{{subLine.delivery.feb.quantity}}</div>
                                </div>
                              </template>
                              <template v-else-if="subLine.delivery && subLine.delivery.feb">
                                <o-input-control :ignore-range="true" :step="1" type="number" v-model="subLine.delivery.feb.quantity"
                                                 @previous-value="setPreviousQuantity($event, subLine, 'feb')"
                                                 @blur="setPrice(subLine, index, 'feb'), setQuantityToChild(subLine, 'feb', subLineIndex)"
                                                 class="form-qty">
                                </o-input-control>
                              </template>
                            </td>
                            <td>
                              <template v-if="isReadonly(subLine, 'mar')">
                                <div class="w-100 form-qty" v-if="subLine.delivery.mar">
                                  <div class="form-control" readonly="readonly">{{subLine.delivery.mar.quantity}}</div>
                                </div>
                              </template>
                              <template v-else-if="subLine.delivery && subLine.delivery.mar">
                                <o-input-control :ignore-range="true" :step="1" type="number" v-model="subLine.delivery.mar.quantity"
                                                 @previous-value="setPreviousQuantity($event, subLine, 'mar')"
                                                 @blur="setPrice(subLine, index, 'mar'), setQuantityToChild(subLine, 'mar', subLineIndex)"
                                                 class="form-qty">
                                </o-input-control>
                              </template>
                            </td>
                            <td>
                              <template v-if="isReadonly(subLine, 'apr')">
                                <div class="w-100 form-qty" v-if="subLine.delivery.apr">
                                  <div class="form-control" readonly="readonly">{{subLine.delivery.apr.quantity}}</div>
                                </div>
                              </template>
                              <template v-else-if="subLine.delivery && subLine.delivery.apr">
                                <o-input-control :ignore-range="true" :step="1" type="number" v-model="subLine.delivery.apr.quantity"
                                                 @previous-value="setPreviousQuantity($event, subLine, 'apr')"
                                                 @blur="setPrice(subLine, index, 'apr'), setQuantityToChild(subLine, 'apr', subLineIndex)"
                                                 class="form-qty">
                                </o-input-control>
                              </template>
                            </td>
                            <td>
                              <template v-if="isReadonly(subLine, 'may')">
                                <div class="w-100 form-qty" v-if="subLine.delivery.may">
                                  <div class="form-control" readonly="readonly">{{subLine.delivery.may.quantity}}</div>
                                </div>
                              </template>
                              <template v-else-if="subLine.delivery && subLine.delivery.may">
                                <o-input-control :ignore-range="true" :step="1" type="number" v-model="subLine.delivery.may.quantity"
                                                 @previous-value="setPreviousQuantity($event, subLine, 'may')"
                                                 @blur="setPrice(subLine, index, 'may'), setQuantityToChild(subLine, 'may', subLineIndex)"
                                                 class="form-qty">
                                </o-input-control>
                              </template>
                            </td>
                            <td>
                              <template v-if="isReadonly(subLine, 'jun')">
                                <div class="w-100 form-qty" v-if="subLine.delivery.jun">
                                  <div class="form-control" readonly="readonly">{{subLine.delivery.jun.quantity}}</div>
                                </div>
                              </template>
                              <template v-else-if="subLine.delivery && subLine.delivery.jun">
                                <o-input-control :ignore-range="true" :step="1" type="number" v-model="subLine.delivery.jun.quantity"
                                                 @previous-value="setPreviousQuantity($event, subLine, 'jun')"
                                                 @blur="setPrice(subLine, index, 'jun'), setQuantityToChild(subLine, 'jun', subLineIndex)"
                                                 class="form-qty">
                                </o-input-control>
                              </template>
                            </td>
                            <td>
                              <template v-if="isReadonly(subLine, 'jul')">
                                <div class="w-100 form-qty" v-if="subLine.delivery.jul">
                                  <div class="form-control" readonly="readonly">{{subLine.delivery.jul.quantity}}</div>
                                </div>
                              </template>
                              <template v-else-if="subLine.delivery && subLine.delivery.jul">
                                <o-input-control :ignore-range="true" :step="1" type="number" v-model="subLine.delivery.jul.quantity"
                                                 @previous-value="setPreviousQuantity($event, subLine, 'jul')"
                                                 @blur="setPrice(subLine, index, 'jul'), setQuantityToChild(subLine, 'jul', subLineIndex)"
                                                 class="form-qty">
                                </o-input-control>
                              </template>
                            </td>
                            <td>
                              <template v-if="isReadonly(subLine, 'aug')">
                                <div class="w-100 form-qty" v-if="subLine.delivery.aug">
                                  <div class="form-control" readonly="readonly">{{subLine.delivery.aug.quantity}}</div>
                                </div>
                              </template>
                              <template v-else-if="subLine.delivery && subLine.delivery.aug">
                                <o-input-control :ignore-range="true" :step="1" type="number" v-model="subLine.delivery.aug.quantity"
                                                 @previous-value="setPreviousQuantity($event, subLine, 'aug')"
                                                 @blur="setPrice(subLine, index, 'aug'), setQuantityToChild(subLine, 'aug', subLineIndex)"
                                                 class="form-qty">
                                </o-input-control>
                              </template>
                            </td>
                            <td>
                              <template v-if="isReadonly(subLine, 'sep')">
                                <div class="w-100 form-qty" v-if="subLine.delivery.sep">
                                  <div class="form-control" readonly="readonly">{{subLine.delivery.sep.quantity}}</div>
                                </div>
                              </template>
                              <template v-else-if="subLine.delivery && subLine.delivery.sep">
                                <o-input-control :ignore-range="true" :step="1" type="number" v-model="subLine.delivery.sep.quantity"
                                                 @previous-value="setPreviousQuantity($event, subLine, 'sep')"
                                                 @blur="setPrice(subLine, index, 'sep'), setQuantityToChild(subLine, 'sep', subLineIndex)"
                                                 class="form-qty">
                                </o-input-control>
                              </template>
                            </td>
                            <td>
                              <template v-if="isReadonly(subLine, 'oct')">
                                <div class="w-100 form-qty" v-if="subLine.delivery.oct">
                                  <div class="form-control" readonly="readonly">{{subLine.delivery.oct.quantity}}</div>
                                </div>
                              </template>
                              <template v-else-if="subLine.delivery && subLine.delivery.oct">
                                <o-input-control :ignore-range="true" :step="1" type="number" v-model="subLine.delivery.oct.quantity"
                                                 @previous-value="setPreviousQuantity($event, subLine, 'oct')"
                                                 @blur="setPrice(subLine, index, 'oct'), setQuantityToChild(subLine, 'oct', subLineIndex)"
                                                 class="form-qty">
                                </o-input-control>
                              </template>
                            </td>
                            <td>
                              <template v-if="isReadonly(subLine, 'nov')">
                                <div class="w-100 form-qty" v-if="subLine.delivery.nov">
                                  <div class="form-control" readonly="readonly">{{subLine.delivery.nov.quantity}}</div>
                                </div>
                              </template>
                              <template v-else-if="subLine.delivery && subLine.delivery.nov">
                                <o-input-control :ignore-range="true" :step="1" type="number" v-model="subLine.delivery.nov.quantity"
                                                 @previous-value="setPreviousQuantity($event, subLine, 'nov')"
                                                 @blur="setPrice(subLine, index, 'nov'), setQuantityToChild(subLine, 'nov', subLineIndex)"
                                                 class="form-qty">
                                </o-input-control>
                              </template>
                            </td>
                            <td>
                              <template v-if="isReadonly(subLine, 'dec')">
                                <div class="w-100 form-qty" v-if="subLine.delivery.dec">
                                  <div class="form-control" readonly="readonly">{{subLine.delivery.dec.quantity}}</div>
                                </div>
                              </template>
                              <template v-else-if="subLine.delivery && subLine.delivery.dec">
                                <o-input-control :ignore-range="true" :step="1" type="number" v-model="subLine.delivery.dec.quantity"
                                                 @previous-value="setPreviousQuantity($event, subLine, 'dec')"
                                                 @blur="setPrice(subLine, index, 'dec'), setQuantityToChild(subLine, 'dec', subLineIndex)"
                                                 class="form-qty">
                                </o-input-control>
                              </template>
                            </td>
                            <td class="d-none">
                              <o-value-select-control v-model="subLine.valid_from_month" :items="months"
                                                      :readonly="!subLine.allow_manual_date_entry"
                                                      @change.native="setDateToChildren(subLine, index, 'from'), setDateChanged(subLine, 'from')">
                              </o-value-select-control>
                            </td>
                            <td class="d-none">
                              <o-value-select-control v-model="subLine.valid_to_month" :items="months"
                                                      :readonly="!subLine.allow_manual_date_entry"
                                                      @change.native="setDateToChildren(subLine, index, 'to'), setDateChanged(subLine, 'to')">
                              </o-value-select-control>
                            </td>
                            <td class="text-right text-nowrap">
                            </td>
                          </tr>
                          <template v-if="subLine.children && Object.keys(subLine.children).length">
                            <template v-for="(childLine, childLineIndex) in subLine.children">
                              <tr :class="{'d-none': (getAccordion(lineIndex, subLineIndex) === -1 ||  getAccordion(index, lineIndex) === -1)}">
                                <td></td>
                                <td class="indention-1" v-if="!childLine.allow_product_name_to_change">{{ childLine.product ? childLine.product.name : childLine.product_name }}
                                  <router-link v-if="user && user.is_super_user && childLine.product && childLine.product.product_master_id" target="_blank"
                                               :to="{ path: '/sandoz/product_masters/' + childLine.product.product_master_id }">
                                    <fa icon="pencil-alt"/>
                                  </router-link>
                                  <a :href="linkValidate(childLine.product.info_link)" target="_blank" v-if="childLine.product && childLine.product.info_link">
                                    <fa icon="file"/>
                                  </a>
                                </td>
                                <td class="indention-1" v-else>
                                  <o-input-control type="text" v-model="childLine.product_name" class="full-width"> </o-input-control>
                                  <router-link v-if="user && user.is_super_user && childLine.product && childLine.product.product_master_id" target="_blank"
                                               :to="{ path: '/sandoz/product_masters/' + childLine.product.product_master_id }">
                                    <fa icon="pencil-alt"/>
                                  </router-link>
                                  <a :href="linkValidate(childLine.product.info_link)" target="_blank" v-if="childLine.product && childLine.product.info_link">
                                    <fa icon="file"/>
                                  </a>
                                </td>
                                <td class="item-price">{{ childLine.item_price | formatPrice }}</td>
                                <td>
                                  <template v-if="childLine.price_changes && childLine.price_changes.price_changes === 'no_changes_allowed'">
                                    <div class="w-100">
                                      <div class="form-control text-right" readonly="readonly">{{childLine.price | formatPrice}}</div>
                                    </div>
                                  </template>
                                  <template v-else>
                                    <o-input-control :min="1" type="number" v-model="childLine.price"
                                                     @blur="validatePrice(childLine, index)" class="form-price"></o-input-control>
                                  </template>
                                </td>
                                <td>
                                  <template v-if="isReadonly(childLine, 'yearly')">
                                    <div class="w-100 form-qty" v-if="childLine.delivery.yearly">
                                      <div class="form-control" readonly="readonly">{{childLine.delivery.yearly.quantity}}</div>
                                    </div>
                                  </template>
                                  <template v-else-if="childLine.delivery.yearly">
                                    <template v-if="childLine.product_master_values && Object.keys(childLine.product_master_values).length">
                                      <o-value-select v-model="childLine.delivery.yearly.quantity"
                                        class="fixed-value-dropdown"
                                        text-field="value"
                                        :items="childLine.product_master_values"
                                        value-field="value"
                                        @previous-value="setPreviousQuantity($event, childLine, 'yearly')"
                                        @change.native="setQuantityToParent(subLine, childLine, 'yearly', index),
                                                      setBoxQuantity(line, 'yearly', childLine.box_or_gadget, index)">
                                      </o-value-select>
                                    </template>
                                    <template v-else>
                                      <o-input-control :ignore-range="true" :step="1" type="number" v-model="childLine.delivery.yearly.quantity"
                                                       @previous-value="setPreviousQuantity($event, childLine, 'yearly')"
                                                       @blur="setQuantityToParent(subLine, childLine, 'yearly', index),
                                                      setBoxQuantity(line, 'yearly', childLine.box_or_gadget, index)"
                                                      class="form-qty">
                                      </o-input-control>
                                    </template>
                                  </template>
                                </td>
                                <td :class="determErrorID.includes(address.id+'-'+childLine.product.id)? 'exist_error': ''">
                                  <template
                                    v-if="childLine.delivery.yearly.quantity > 0 || childLine.delivery.q1.quantity > 0 || childLine.delivery.q2.quantity > 0 || childLine.delivery.q3.quantity > 0 || childLine.delivery.q4.quantity > 0 || childLine.delivery.jan || childLine.delivery.jan || childLine.delivery.feb || childLine.delivery.mar || childLine.delivery.apr || childLine.delivery.may || childLine.delivery.jun || childLine.delivery.jul || childLine.delivery.aug || childLine.delivery.sep || childLine.delivery.oct || childLine.delivery.nov || childLine.delivery.dec">
                                    <template
                                      v-if="childLine.attribute_required || childLine.exist_value !== null">
                                      <b-form-checkbox v-model="childLine.contract_line_exist_attribute"
                                                       :disabled="readonly || childLine.exist_value !== null"
                                                       :indeterminate="childLine.exist_value === null && !!childLine.indeterminate">
                                      </b-form-checkbox>
                                    </template>
                                  </template>
                                </td>
                                <td>
                                  <template v-if="isReadonly(childLine, 'q1', true)">
                                    <div class="w-100 form-qty" v-if="childLine.delivery.q1">
                                      <div class="form-control" readonly="readonly" :class="childLine.sync_quarter_q1 ? 'sync_quarter' : ''">{{childLine.delivery.q1.quantity}}</div>
                                    </div>
                                  </template>
                                  <template v-else>
                                    <o-input-control :ignore-range="true" :step="1" type="number" v-model="childLine.delivery.q1.quantity"
                                                     @previous-value="setPreviousQuantity($event, childLine, 'q1')"
                                                     @blur="setQuantityToParent(subLine, childLine, 'q1', index),
                                                     setBoxQuantity(line, 'q1', childLine.box_or_gadget, index)"
                                                     class="form-qty">
                                    </o-input-control>
                                  </template>
                                </td>
                                <td>
                                  <template v-if="isReadonly(childLine, 'q2', true)">
                                    <div class="w-100 form-qty" v-if="childLine.delivery.q2">
                                      <div class="form-control" readonly="readonly" :class="childLine.sync_quarter_q2 ? 'sync_quarter' : ''">{{childLine.delivery.q2.quantity}}</div>
                                    </div>
                                  </template>
                                  <template v-else>
                                    <o-input-control :ignore-range="true" :step="1" type="number" v-model="childLine.delivery.q2.quantity"
                                                     @previous-value="setPreviousQuantity($event, childLine, 'q2')"
                                                     @blur="setQuantityToParent(subLine, childLine, 'q2', index),
                                                     setBoxQuantity(line, 'q2', childLine.box_or_gadget, index)"
                                                     class="form-qty">
                                    </o-input-control>
                                  </template>
                                </td>
                                <td>
                                  <template v-if="isReadonly(childLine, 'q3', true)">
                                    <div class="w-100 form-qty" v-if="childLine.delivery.q3">
                                      <div class="form-control" readonly="readonly" :class="childLine.sync_quarter_q3 ? 'sync_quarter' : ''">{{childLine.delivery.q3.quantity}}</div>
                                    </div>
                                  </template>
                                  <template v-else>
                                    <o-input-control :ignore-range="true" :step="1" type="number" v-model="childLine.delivery.q3.quantity"
                                                     @previous-value="setPreviousQuantity($event, childLine, 'q3')"
                                                     @blur="setQuantityToParent(subLine, childLine, 'q3', index),
                                                     setBoxQuantity(line, 'q3', childLine.box_or_gadget, index)"
                                                     class="form-qty">
                                    </o-input-control>
                                  </template>
                                </td>
                                <td>
                                  <template v-if="isReadonly(childLine, 'q4', true)">
                                    <div class="w-100 form-qty" v-if="childLine.delivery.q4">
                                      <div class="form-control form-qty" readonly="readonly" :class="childLine.sync_quarter_q4 ? 'sync_quarter' : ''">{{childLine.delivery.q4.quantity}}</div>
                                    </div>
                                  </template>
                                  <template v-else>
                                    <o-input-control :ignore-range="true" :step="1" type="number" v-model="childLine.delivery.q4.quantity"
                                                     @previous-value="setPreviousQuantity($event, childLine, 'q4')"
                                                     @blur="setQuantityToParent(subLine, childLine, 'q4', index),
                                                     setBoxQuantity(line, 'q4', childLine.box_or_gadget, index)"
                                                     class="form-qty">
                                    </o-input-control>
                                  </template>
                                </td>
                                <td>
                                  <template v-if="isReadonly(line, 'jan')">
                                    <div class="w-100 form-qty" v-if="childLine.delivery.jan">
                                      <div class="form-control" readonly="readonly">{{childLine.delivery.jan.quantity}}</div>
                                    </div>
                                  </template>
                                  <template v-else-if="childLine.delivery && childLine.delivery.jan">
                                    <o-input-control :ignore-range="true" :step="1" type="number" v-model="childLine.delivery.jan.quantity"
                                                     @previous-value="setPreviousQuantity($event, childLine, 'jan')"
                                                     @blur="setQuantityToParent(subLine, childLine, 'jan', index),
                                                     setBoxQuantity(line, 'jan', childLine.box_or_gadget, index)"
                                                     class="form-qty">
                                    </o-input-control>
                                  </template>
                                </td>
                                <td>
                                  <template v-if="isReadonly(line, 'feb')">
                                    <div class="w-100 form-qty" v-if="childLine.delivery.feb">
                                      <div class="form-control" readonly="readonly">{{childLine.delivery.feb.quantity}}</div>
                                    </div>
                                  </template>
                                  <template v-else-if="childLine.delivery && childLine.delivery.feb">
                                    <o-input-control :ignore-range="true" :step="1" type="number" v-model="childLine.delivery.feb.quantity"
                                                     @previous-value="setPreviousQuantity($event, childLine, 'feb')"
                                                     @blur="setQuantityToParent(subLine, childLine, 'feb', index),
                                                     setBoxQuantity(line, 'feb', childLine.box_or_gadget, index)"
                                                     class="form-qty">
                                    </o-input-control>
                                  </template>
                                </td>
                                <td>
                                  <template v-if="isReadonly(childLine, 'mar')">
                                    <div class="w-100 form-qty" v-if="childLine.delivery.mar">
                                      <div class="form-control" readonly="readonly">{{childLine.delivery.mar.quantity}}</div>
                                    </div>
                                  </template>
                                  <template v-else-if="childLine.delivery && childLine.delivery.mar">
                                    <o-input-control :ignore-range="true" :step="1" type="number" v-model="childLine.delivery.mar.quantity"
                                                     @previous-value="setPreviousQuantity($event, childLine, 'mar')"
                                                     @blur="setQuantityToParent(subLine, childLine, 'mar', index),
                                                     setBoxQuantity(line, 'mar', childLine.box_or_gadget, index)"
                                                     class="form-qty">
                                    </o-input-control>
                                  </template>
                                </td>
                                <td>
                                  <template v-if="isReadonly(childLine, 'apr')">
                                    <div class="w-100 form-qty" v-if="childLine.delivery.apr">
                                      <div class="form-control" readonly="readonly">{{childLine.delivery.apr.quantity}}</div>
                                    </div>
                                  </template>
                                  <template v-else-if="childLine.delivery && childLine.delivery.apr">
                                    <o-input-control :ignore-range="true" :step="1" type="number" v-model="childLine.delivery.apr.quantity"
                                                     @previous-value="setPreviousQuantity($event, childLine, 'apr')"
                                                     @blur="setQuantityToParent(subLine, childLine, 'apr', index),
                                                     setBoxQuantity(line, 'apr', childLine.box_or_gadget, index)"
                                                     class="form-qty">
                                    </o-input-control>
                                  </template>
                                </td>
                                <td>
                                  <template v-if="isReadonly(childLine, 'may')">
                                    <div class="w-100 form-qty" v-if="childLine.delivery.may">
                                      <div class="form-control" readonly="readonly">{{childLine.delivery.may.quantity}}</div>
                                    </div>
                                  </template>
                                  <template v-else-if="childLine.delivery && childLine.delivery.may">
                                    <o-input-control :ignore-range="true" :step="1" type="number" v-model="childLine.delivery.may.quantity"
                                                     @previous-value="setPreviousQuantity($event, childLine, 'may')"
                                                     @blur="setQuantityToParent(subLine, childLine, 'may', index),
                                                     setBoxQuantity(line, 'may', childLine.box_or_gadget, index)"
                                                     class="form-qty">
                                    </o-input-control>
                                  </template>
                                </td>
                                <td>
                                  <template v-if="isReadonly(childLine, 'jun')">
                                    <div class="w-100 form-qty" v-if="childLine.delivery.jun">
                                      <div class="form-control" readonly="readonly">{{childLine.delivery.jun.quantity}}</div>
                                    </div>
                                  </template>
                                  <template v-else-if="childLine.delivery && childLine.delivery.jun">
                                    <o-input-control :ignore-range="true" :step="1" type="number" v-model="childLine.delivery.jun.quantity"
                                                     @previous-value="setPreviousQuantity($event, childLine, 'jun')"
                                                     @blur="setQuantityToParent(subLine, childLine, 'jun', index),
                                                     setBoxQuantity(line, 'jun', childLine.box_or_gadget, index)"
                                                     class="form-qty">
                                    </o-input-control>
                                  </template>
                                </td>
                                <td>
                                  <template v-if="isReadonly(childLine, 'jul')">
                                    <div class="w-100 form-qty" v-if="childLine.delivery.jul">
                                      <div class="form-control" readonly="readonly">{{childLine.delivery.jul.quantity}}</div>
                                    </div>
                                  </template>
                                  <template v-else-if="childLine.delivery && childLine.delivery.jul">
                                    <o-input-control :ignore-range="true" :step="1" type="number" v-model="childLine.delivery.jul.quantity"
                                                     @previous-value="setPreviousQuantity($event, childLine, 'jul')"
                                                     @blur="setQuantityToParent(subLine, childLine, 'jul', index),
                                                     setBoxQuantity(line, 'jul', childLine.box_or_gadget, index)"
                                                     class="form-qty">
                                    </o-input-control>
                                  </template>
                                </td>
                                <td>
                                  <template v-if="isReadonly(childLine, 'aug')">
                                    <div class="w-100 form-qty" v-if="childLine.delivery.aug">
                                      <div class="form-control" readonly="readonly">{{childLine.delivery.aug.quantity}}</div>
                                    </div>
                                  </template>
                                  <template v-else-if="childLine.delivery && childLine.delivery.aug">
                                    <o-input-control :ignore-range="true" :step="1" type="number" v-model="childLine.delivery.aug.quantity"
                                                     @previous-value="setPreviousQuantity($event, childLine, 'aug')"
                                                     @blur="setQuantityToParent(subLine, childLine, 'aug', index),
                                                     setBoxQuantity(line, 'aug', childLine.box_or_gadget, index)"
                                                     class="form-qty">
                                    </o-input-control>
                                  </template>
                                </td>
                                <td>
                                  <template v-if="isReadonly(childLine, 'sep')">
                                    <div class="w-100 form-qty" v-if="childLine.delivery.sep">
                                      <div class="form-control" readonly="readonly">{{childLine.delivery.sep.quantity}}</div>
                                    </div>
                                  </template>
                                  <template v-else-if="childLine.delivery && childLine.delivery.sep">
                                    <o-input-control :ignore-range="true" :step="1" type="number" v-model="childLine.delivery.sep.quantity"
                                                     @previous-value="setPreviousQuantity($event, childLine, 'sep')"
                                                     @blur="setQuantityToParent(subLine, childLine, 'sep', index),
                                                     setBoxQuantity(line, 'sep', childLine.box_or_gadget, index)"
                                                     class="form-qty">
                                    </o-input-control>
                                  </template>
                                </td>
                                <td>
                                  <template v-if="isReadonly(childLine, 'oct')">
                                    <div class="w-100 form-qty" v-if="childLine.delivery.oct">
                                      <div class="form-control" readonly="readonly">{{childLine.delivery.oct.quantity}}</div>
                                    </div>
                                  </template>
                                  <template v-else-if="childLine.delivery && childLine.delivery.oct">
                                    <o-input-control :ignore-range="true" :step="1" type="number" v-model="childLine.delivery.oct.quantity"
                                                     @previous-value="setPreviousQuantity($event, childLine, 'oct')"
                                                     @blur="setQuantityToParent(subLine, childLine, 'oct', index),
                                                     setBoxQuantity(line, 'oct', childLine.box_or_gadget, index)"
                                                     class="form-qty">
                                    </o-input-control>
                                  </template>
                                </td>
                                <td>
                                  <template v-if="isReadonly(childLine, 'nov')">
                                    <div class="w-100 form-qty" v-if="childLine.delivery.nov">
                                      <div class="form-control" readonly="readonly">{{childLine.delivery.nov.quantity}}</div>
                                    </div>
                                  </template>
                                  <template v-else-if="childLine.delivery && childLine.delivery.nov">
                                    <o-input-control :ignore-range="true" :step="1" type="number" v-model="childLine.delivery.nov.quantity"
                                                     @previous-value="setPreviousQuantity($event, childLine, 'nov')"
                                                     @blur="setQuantityToParent(subLine, childLine, 'nov', index),
                                                     setBoxQuantity(line, 'nov', childLine.box_or_gadget, index)"
                                                     class="form-qty">
                                    </o-input-control>
                                  </template>
                                </td>
                                <td>
                                  <template v-if="isReadonly(childLine, 'dec')">
                                    <div class="w-100 form-qty" v-if="childLine.delivery.dec">
                                      <div class="form-control" readonly="readonly">{{childLine.delivery.dec.quantity}}</div>
                                    </div>
                                  </template>
                                  <template v-else-if="childLine.delivery && childLine.delivery.dec">
                                    <o-input-control :ignore-range="true" :step="1" type="number" v-model="childLine.delivery.dec.quantity"
                                                     @previous-value="setPreviousQuantity($event, childLine, 'dec')"
                                                     @blur="setQuantityToParent(subLine, childLine, 'dec', index),
                                                     setBoxQuantity(line, 'dec', childLine.box_or_gadget, index)"
                                                     class="form-qty">
                                    </o-input-control>
                                  </template>
                                </td>
                                <td class="d-none">
                                  <o-value-select-control v-model="childLine.valid_from_month" :items="months"
                                                          :readonly="!childLine.allow_manual_date_entry"
                                                          @change.native="setPrice(childLine, index), setDateChanged(childLine, 'from')">
                                  </o-value-select-control>
                                </td>
                                <td class="d-none">
                                  <o-value-select-control v-model="childLine.valid_to_month" :items="months"
                                                          :readonly="!childLine.allow_manual_date_entry"
                                                          @change.native="setPrice(childLine, index), setDateChanged(childLine, 'to')">
                                  </o-value-select-control>
                                </td>
                              </tr>
                            </template>
                          </template>
                        </template>
                      </template>
                    </template>
                    </tbody>
                    <tbody v-else>
                    <tr>
                      <td align="center" colspan="11">{{ $t('core.no_records') }}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </template>
            </template>
            <template #overlay>
              <div class="text-center">
                <p>{{$t('sandoz.set_type_first')}}</p>
              </div>
            </template>
          </b-overlay>
        </b-tab>

      </b-tabs>

      <address-search ref="addressSearch" :address-mode-checkbox="showAddressModeCheckbox" contract-type="apoone"
                      @address-selected="addressSelected"></address-search>
    </o-card>
    <o-action-toolbar>
      <div class="d-flex w-100">
        <o-button type="button" variant="outline-primary" @click.prevent="back">{{ $t('core.back') }}</o-button>
        <template-download-button v-if="$route.params.id !== 'new'" :contract-id="$route.params.id" class="ml-2"/>
        <div class="ml-auto">
          <o-button
            v-if="(user && user.is_super_user && item && (item.status == 'Committed' || item.status == 'Approved' || item.status == 'Signed'))"
            :loading="saving" type="button" variant="primary"
            @click.prevent="$refs.resetContractModel.show()">{{ $t('sandoz.reset_to_draft') }}
          </o-button>
          <o-button v-if="(item && (item.status == 'Draft' || item.status == 'Feedback'))" :loading="saving" type="button" variant="primary"
                    @click.prevent="contractCanApprovable">{{ $t('sandoz.upload_start_approval') }}
          </o-button>
          <o-button v-if="(item && (item.status == 'Draft'))" :loading="saving" type="button" variant="primary"
                    @click.prevent="save">{{ $t('sandoz.save_draft') }}
          </o-button>
          <o-button v-if="(item && (item.status == 'Feedback'))" :loading="saving" type="button" variant="primary"
                    @click.prevent="save">{{ $t('core.save') }}
          </o-button>
        </div>
      </div>
    </o-action-toolbar>
    <b-modal id="modal-previous-contract" ref="addPreviousContractModel" :ok-only="true"
             :ok-title="$t('core.cancel')" :title="$t('sandoz.select_previous_contract')" size="xl">
      <o-table ref="previousContractList" :enable-delete="false" :enable-edit="false"
               :enable-new="false"
               :only-filterable="true" :shadow="false" title=""
               url="/api/sandoz/contracts?include=master_address_single">
        <template slot="filter">
          <o-filter v-on:filter-updated="(filters) => $refs.previousContractList.setFilters(filters)">
            <o-filter-text :title="$t('sandoz.contract_no')" column="contract_no"></o-filter-text>
            <o-filter-text :title="$t('sandoz.customer_external_id')" column="customer_external_id"></o-filter-text>
            <o-filter-select :items="years" :title="$t('sandoz.contract_year')"
                             column="contract_year"></o-filter-select>
          </o-filter>
        </template>
        <template slot="head">
          <o-table-header column="contract_no">{{ $t('sandoz.contract_no') }}</o-table-header>
          <o-table-header column="customer_external_id">{{ $t('sandoz.customer_external_id') }}</o-table-header>
          <o-table-header column="contract_year">{{ $t('sandoz.contract_year') }}</o-table-header>
          <o-table-header :sortable="false">{{ $t('sandoz.name') }}</o-table-header>
          <o-table-header :sortable="false">{{ $t('sandoz.last_name') }}</o-table-header>
          <o-table-header :sortable="false">{{ $t('sandoz.company_name') }}</o-table-header>
          <o-table-header :sortable="false">{{ $t('sandoz.street') }}</o-table-header>
          <o-table-header :sortable="false">{{ $t('sandoz.zip') }}</o-table-header>
          <o-table-header :sortable="false">{{ $t('sandoz.city') }}</o-table-header>
        </template>
        <template slot="body" slot-scope="previousContractProps">
          <td>{{ previousContractProps.item.contract_no }}</td>
          <td>{{ previousContractProps.item.customer_external_id }}</td>
          <td>{{ previousContractProps.item.contract_year }}</td>
          <td>{{
              previousContractProps.item.master_address_single && previousContractProps.item.master_address_single.data ?
                previousContractProps.item.master_address_single.data.name : ''
            }}
          </td>
          <td>{{
              previousContractProps.item.master_address_single && previousContractProps.item.master_address_single.data ?
                previousContractProps.item.master_address_single.data.last_name : ''
            }}
          </td>
          <td>{{
              previousContractProps.item.master_address_single && previousContractProps.item.master_address_single.data ?
                previousContractProps.item.master_address_single.data.company_name : ''
            }}
          </td>
          <td>{{
              previousContractProps.item.master_address_single && previousContractProps.item.master_address_single.data ?
                previousContractProps.item.master_address_single.data.street : ''
            }}
          </td>
          <td>{{
              previousContractProps.item.master_address_single && previousContractProps.item.master_address_single.data ?
                previousContractProps.item.master_address_single.data.zip : ''
            }}
          </td>
          <td>{{
              previousContractProps.item.master_address_single && previousContractProps.item.master_address_single.data ?
                previousContractProps.item.master_address_single.data.city : ''
            }}
          </td>
        </template>
        <template slot="body-controls" slot-scope="previousContractProps">
          <td class="text-right">
            <div v-if="previousContractProps.item.id === item.id">
              <span class="badge badge-success">Current </span>
            </div>
            <div v-else-if="previousContractProps.item.id === item.previous_contract">
              <span class="badge badge-warning">Previous</span>
            </div>
            <div v-else aria-label="edit controls" class="btn-group btn-group-sm" role="group">
              <b-btn variant="primary" @click="addPreviousContract(previousContractProps.item)">
                <fa icon="arrow-right"/>
              </b-btn>
            </div>
          </td>
        </template>
      </o-table>
    </b-modal>
    <b-modal id="modal-reset-contract" ref="resetContractModel" :title="$t('sandoz.reset_to_draft')">
      {{ $t('sandoz.reset_confirmation') }}
      <template #modal-footer="{ ok, cancel, hide }">
        <b-button variant="secondary" @click="cancel()">
          {{ $t('core.cancel') }}
        </b-button>
        <b-button variant="primary" @click="resetToDraft()">
          {{ $t('core.ok') }}
        </b-button>
      </template>
    </b-modal>
    <b-modal id="modal-duplicate-contract" ref="duplicateContractModel" :title="$t('sandoz.duplicate_contract')">
      {{ $t('sandoz.duplicate_contract_error') }}
      <template #modal-footer="{ ok, cancel, hide }">
        <b-button variant="secondary" @click="showDuplicateContract">
          {{ $t('sandoz.show_contract') }}
        </b-button>
        <b-button variant="primary" @click="cancel()">
          {{ $t('core.ok') }}
        </b-button>
      </template>
    </b-modal>
    <b-modal id="modal-past-contract" ref="pastContractModel" :title="$t('sandoz.past_contract')">
      {{$t('sandoz.past_contract_warning')}}
      <template #modal-footer="{ ok, cancel, hide }">
        <b-button variant="secondary" @click="cancel()">
          {{$t('core.cancel')}}
        </b-button>
        <b-button variant="primary" @click="saveAndStartApproval()">
          {{ $t('sandoz.upload_start_approval') }}
        </b-button>
      </template>
    </b-modal>
  </form>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import AddressSearch from '../partials/AddressSearch.vue'
import OValueSelectControl from '../../../components/OrticValueSelectControl.vue'
import moment from 'moment'
import TemplateDownloadButton from '../partials/TemplateDownloadButton.vue'
import contractYearMixin from '../../../mixins/contractYearMixin'

export default {
  mixins: [contractYearMixin],
  components: {
    OValueSelectControl,
    AddressSearch,
    TemplateDownloadButton
  },
  data: () => ({
    contractTypes: [],
    years: [],
    item: null,
    watchers: [],
    saving: false,
    toggleItems: false,
    listItem: [],
    selectedItems: [],
    searchItem: null,
    months: [],
    loaded: false,
    currentUser: null,
    watcherWorking: false,
    showAddressModeCheckbox: false,
    changeExternalID: false,
    downloadPDF: false,
    itemOld: null,
    languages: [],
    setLang: false,
    accordionItems: [],
    showContract: null,
    determErrorID: [],
    isCommentError: false
  }),
  mounted () {
    this.loadData()
  },
  computed: {
    ...mapGetters({
      user: 'auth/user'
    }),
    readonly () {
      return this.item && this.item.status != 'Draft' && this.item.status != 'Feedback'
    }
  },
  watch: {
    'item.contract_start': function (newVal) {
      this.setContractDateToItems()
    }
  },
  created () {
    this.updateContractYears()
    this.months = [
      { value: '01', text: this.$i18n.t('core.january_short') },
      { value: '02', text: this.$i18n.t('core.february_short') },
      { value: '03', text: this.$i18n.t('core.march_short') },
      { value: '04', text: this.$i18n.t('core.april_short') },
      { value: '05', text: this.$i18n.t('core.may_short') },
      { value: '06', text: this.$i18n.t('core.june_short') },
      { value: '07', text: this.$i18n.t('core.july_short') },
      { value: '08', text: this.$i18n.t('core.august_short') },
      { value: '09', text: this.$i18n.t('core.september_short') },
      { value: '10', text: this.$i18n.t('core.october_short') },
      { value: '11', text: this.$i18n.t('core.november_short') },
      { value: '12', text: this.$i18n.t('core.december_short') }
    ]

    this.languages = [
      { value: 'DE', text: 'DE' },
      { value: 'FR', text: 'FR' },
      { value: 'IT', text: 'IT' }
    ]
  },
  methods: {
    loadData () {
      this.saving = true
      this.url = `/api/sandoz/apo-one/contracts/${this.$route.params.id}`
      axios
        .get(`/api/sandoz/apo-one/contracts/detail/${this.$route.params.id}`)
        .then((response) => {
          var item = response
          if (this.dataKey) {
            item = response[this.dataKey]
          }
          this.item = item.data
          this.updateContractYears()

          // set default user
          if (!this.item.user_id) {
            this.item.user_id = this.user.id
          }

          this.getAddressItemData()
          this.setContractNo()
        })
    },
    enableWatchers () {
      this.watchers.push(this.$watch('item.customer_external_id', (newVal) => {
        this.changeExternalID = true
        this.setContractNo()
        this.setPreviousContract()
      }))
      this.watchers.push(this.$watch('item.contract_year', (newVal) => {
        this.setContractNo()
        this.setPreviousContract()
        this.addItemsToAddresses()
        this.changeContractDuration()
      }))
      this.watchers.push(this.$watch('currentUser', (newVal) => {
        this.setApprovers()
      }))
      this.watchers.push(this.$watch('item.language', (newVal) => {
        this.addItemsToAddresses()
        this.setLang = true
      }))
    },
    disableWatchers () {

    },
    contractCanApprovable() {
      /*if(this.item.contract_start && moment().isAfter(this.item.contract_start)) {
        if(this.user.is_super_user) {
          this.$refs.pastContractModel.show()
          return
        } else {
          this.$notify({
            title: this.$i18n.t('core.save_error'),
            text: this.$i18n.t('sandoz.past_contract_error'),
            type: 'error'
          })
          return
        }
      }*/
      this.saveAndStartApproval()
    },
    saveAndStartApproval () {
      if(this.item.contract_start && moment().isAfter(this.item.contract_start)) {
        if (this.user.is_super_user && !this.item.super_user_comment) {
          this.activeTab = 0
          this.isCommentError = true
          this.$notify({
            title: this.$i18n.t('core.save_error'),
            text: this.$i18n.t('sandoz.super_user_comment_error'),
            type: 'error'
          })
          return
        }
      }

      this.item.status = 'Committed'
      this.save()
    },
    resetToDraft () {
      this.item.status = 'Draft'

      this.item.approval_date_1 = null
      this.item.approval_person_1 = null

      this.item.approval_date_2 = null
      this.item.approval_person_2 = null

      this.item.approval_date_3 = null
      this.item.approval_person_3 = null

      this.item.approval_date_4 = null
      this.item.approval_person_4 = null

      this.item.approval_date_5 = null
      this.item.approval_person_5 = null

      this.item.approval_date_6 = null
      this.item.approval_person_6 = null

      this.item.next_approver = null
      this.item.contract_version = (!this.item.contract_version || this.item.contract_version == 1) ? 2 : this.item.contract_version + 1
      this.save(true)
      this.$refs.resetContractModel.hide()
    },
    save (skipValidation = false) {
      var url = this.url
      var route = this.$route

      // this happens if we create a new data record and update it right away without navigating way. We'll still have
      // new in our url, but we don't want to create a new record, we want to update the record we just created.
      // @TODO we should do this in a more elegant way that doesn't require search & replace
      if (url.indexOf('/new') > 0 && 'id' in this.item) {
        url = url.replace('/new', '/' + this.item.id)
      }

      var root = this.$root
      var self = this

      if(!skipValidation) {
        if(self.item.customer_external_id ===  null) {
          self.$notify({
            title: self.$i18n.t('core.validation_error'),
            text: self.$i18n.t('core.validation_error_text', { message: self.$i18n.t('sandoz.external_id_required') }),
            type: 'error'
          })
          return
        }

        if(self.item.contract_year ===  null) {
          self.$notify({
            title: self.$i18n.t('core.validation_error'),
            text: self.$i18n.t('core.validation_error_text', { message: self.$i18n.t('sandoz.contract_year_required') }),
            type: 'error'
          })
          return
        }

        if(self.item.new_customer === 'NA') {
          self.$notify({
            title: self.$i18n.t('core.validation_error'),
            text: self.$i18n.t('core.validation_error_text', { message: self.$i18n.t('sandoz.new_customer_required') }),
            type: 'error'
          })
          return
        }

        if(self.displayBusinessCase() && (self.item.reason_businesscase === '' || self.item.reason_businesscase === null)) {
          self.$notify({
            title: self.$i18n.t('core.validation_error'),
            text: self.$i18n.t('core.validation_error_text', { message: self.$i18n.t('sandoz.reason_businesscase_required') }),
            type: 'error'
          })
          return
        }

        if(self.item.new_customer === null && (self.item.previous_contract === undefined || self.item.previous_contract === null)) {
          self.$notify({
            title: self.$i18n.t('core.validation_error'),
            text: self.$i18n.t('core.validation_error_text', { message: self.$i18n.t('sandoz.previous_contract_required') }),
            type: 'error'
          })
          return
        }

        if(!self.sortalysContract) {
          var indeterminantEror = self.checkIndeterminantCheckbox();
          if(indeterminantEror) {
            self.$notify({
              title: self.$i18n.t('core.validation_error'),
              text: self.$i18n.t('core.validation_error_text', { message: self.$i18n.t('sandoz.indeterminat_error') }),
              type: 'error'
            })
            return
          }
        }
      }

      this.disableWatchers()
      if (this.$refs.pastContractModel && this.$refs.pastContractModel.isVisible) {
        this.$refs.pastContractModel.hide()
      }

      this.saving = true
      this.showContract = null

      axios
        .post(url, this.item)
        .then((response) => {
          let savedItem = response.data
          // this.item = response.data

          // assign our new id to the route params in case someone wants to work with it
          if ('id' in response.data) {
            route.params.id = response.data.id
          }

          if ('updated_at' in response.data) {
            this.$set(this.item, 'updated_at', response.data.updated_at)
          }

          this.$notify({
            title: this.$i18n.t('core.saved'),
            text: this.$i18n.t('core.saved_text')
          })

          // remove all error states
          var elements = document.querySelectorAll('.has-error')
          elements.forEach((element) => {
            element.classList.remove('has-error')
          })

          // clear all errors
          root.errors = {}
          this.isCommentError = false
          if (this.downloadPDF) {
            this.pdfContract()
            this.downloadPDF = false
          } else {
            this.loaded = true
            this.setWholesalers(savedItem)
            this.getAddressItemData()
            this.saving = false
          }
        })
        .catch((error) => {
          // stop loading indicator
          self.saving = false

          if (error.response.status === 409) {
            this.$bvModal.msgBoxConfirm(self.$i18n.t('core.concurrent_modification_text') || 'Data was changed by another process. Do you want to reload the page to see the new data?', {
                title: self.$i18n.t('core.concurrent_modification') || 'Data Changed',
                size: 'md',
                buttonSize: 'sm',
                okVariant: 'primary',
                okTitle: self.$i18n.t('core.reload') || 'Reload Page',
                cancelTitle: self.$i18n.t('core.cancel') || 'Cancel',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            }).then(value => {
                if(value) {
                    window.location.reload();
                }
            })
          } else if (error.response.status === 422 && 'data' in error.response && 'message' in error.response.data) {
            this.$notify({
              title: this.$i18n.t('core.validation_error'),
              text: this.$i18n.t('core.validation_error_text', { message: error.response.data.message }),
              type: 'error'
            })
            if ('data' in error.response && 'errors' in error.response.data) {
              root.errors = error.response.data.errors
            }
          } else {
            if (error.response.data && 'contract_error' in error.response.data && error.response.data.contract_error === 'contract_already_exists') {
              this.showContract = error.response.data.contract
              this.$refs.duplicateContractModel.show()
            } else {
              this.$notify({
                title: this.$i18n.t('core.save_error'),
                text: this.$i18n.t('core.save_error_text', { url: this.url }),
                type: 'error'
              })
            }
          }
        })
    },
    back () {
      this.$router.back()
    },
    setContractNo () {
      if (!this.item.type || !this.item.customer_external_id) {
        return
      }

      var contractNo = `${this.item.type}-${this.item.contract_year - 2000}-${this.item.customer_external_id}`
      if (this.item.addresses.length > 0) {
        let currentAdr = this.item.addresses[0]
        if(currentAdr.company_name) {
          contractNo += `-${currentAdr.company_name}`
        }

        if(currentAdr.city) {
          contractNo += `-${currentAdr.city}`
        }
      }
      this.item.contract_no = contractNo
    },
    setCurrentUser (user) {
      if (!user) {
        return
      }
      this.currentUser = user
    },
    changeContractDuration() {
      const startDate = moment(this.item.contract_start)
      const startYear = startDate.format('YYYY')
      if(startYear !== this.item.contract_year) {
        this.item.contract_start = this.item.contract_year + '-01-01'
      }
    },
    setApprover (num, val) {
      if (this.item['approver_' + num] != val) {
        this.item['approver_' + num] = val

        // clear existing
        for (let i = num; i < 6; i++) {
          this.item['approval_date_' + i] = null
          this.item['approval_person_' + i] = null
        }

        // reset next approver if needed
        this.item.next_approver = Math.min(this.item.next_approver, num)
      }
    },
    setApprovers () {
      if (this.item.status != 'Draft' && this.item.status != 'Feedback') {
        return
      }
      if (!this.item.type) {
        return
      }
      if (!this.currentUser) {
        return
      }

      this.$forceUpdate()
    },
    addPreviousContract (contract) {
      this.item.previous_contract = contract.id
      this.item.previous = contract
      this.$refs.addPreviousContractModel.hide()
    },
    setPreviousContract (fromNewCustomer = false) {
      if (this.item.customer_external_id !== null && this.item.contract_year !== '' && this.item.type !== null) {
        var params = {
          customer_external_id: this.item.customer_external_id,
          contract_year: this.item.contract_year,
          type: this.item.type
        }
        let url = '/api/sandoz/apo-one/contracts/get-previous-contract'
        axios.post(url, params)
          .then((response) => {
            const self = this
            let previousContract = response.data.previousContract
            if (previousContract) {
              self.item.previous_contract = previousContract.id
              self.item.previous = previousContract
            } else {
              self.item.previous_contract = null
              self.item.previous = null
            }
          })
      }
    },
    checkLangSelection () {
      if ('id' in this.item) {
        return this.item.language !== '' ? true : false
      } else {
        return this.item.language !== '' && this.setLang === true ? true : false
      }
    },
    setMasterAddress () {
      this.addressMode = 'master'
      this.$refs.addressSearch.showAddressSearchModal(this)
    },
    addressSelected (addressEvent) {
      let address = addressEvent.address
      // set external id
      let externalId = address.customer_no
      this.item.customer_external_id = externalId

      if (this.item.addresses.length > 0) {
        let currentAdr = this.item.addresses[0]
        currentAdr.customer_no_xpris = this.item.customer_external_id
        currentAdr.last_name = address.person_name
        currentAdr.company_name = address.company_name
        currentAdr.street = address.street
        currentAdr.zip = address.zip_code
        currentAdr.city = address.city
      } else {
        var addressObj = {
          address_type: 'master',
          customer_no_xpris: this.item.customer_external_id,
          last_name: address.person_name,
          company_name: address.company_name,
          street: address.street,
          zip: address.zip_code,
          city: address.city,
          items: []
        }
        this.item.addresses.push(addressObj)
      }
      this.addItemsToAddresses(false)
      this.setContractDateToItems()
    },
    getAddressItemData () {
      var url = `/api/sandoz/apo-one/contracts/detail/${this.$route.params.id}`
      axios
        .get(url)
        .then((response) => {
          var item = response
          this.item.addresses = item.data.addresses
          this.$nextTick(() => {
            this.loaded = true
            this.addItemsToAddresses(false)
            this.setSelectedItemPrice()
            this.itemOld = {...this.item}
            this.setContractDateToItems()
            this.enableWatchers()
            this.$nextTick(() => {
              this.setDefaultPrice()
              this.saving = false
            })
          })
        })
    },
    setCalculatedInvest() {
      if (!this.item.invest_turnover) {
        return
      }
      if (!this.item.invest_turnover_forecast) {
        return
      }

      this.item.invest_max = parseFloat(this.item.invest_turnover) + parseFloat(this.item.invest_turnover_forecast)
      this.item.invest_max_percentage = this.item.invest_max / parseFloat(this.item.turnover_expectation)

      this.$forceUpdate()
    },
    setTurnoverInvest () {
      var url = `/api/sandoz/sales_lines?filter[sales_line]=${this.item.type}`
      axios
        .get(url)
        .then((response) => {
          if(response.data.data && '0' in response.data.data) {
            var maximumInvest = response.data.data[0].maximum_invest
            if(maximumInvest) {
              this.item.invest_turnover = parseFloat(this.item.turnover * maximumInvest).toFixed(2)
              this.item.invest_turnover_percentage = maximumInvest
            } else {
              this.item.invest_turnover = null
              this.item.invest_turnover_percentage = null
            }
          }
        })
    },
    setTurnoverExpectation () {
      var url = `/api/sandoz/sales_lines?filter[sales_line]=${this.item.type}`
      axios
        .get(url)
        .then((response) => {
          if(response.data.data && '0' in response.data.data) {
            let maximumInvestExpectation = response.data.data[0].maximum_invest_expectation
            if(maximumInvestExpectation) {
              this.item.invest_growth = maximumInvestExpectation
              this.item.invest_turnover_forecast = parseFloat(this.item.growth_forecast * maximumInvestExpectation).toFixed(2)
            } else {
              this.item.invest_growth = null
              this.item.invest_turnover_forecast = null
            }
          }
        })
    },
    setWithoutWatcher(propertyName, value) {
      if (this.watcherWorking || !this.loaded) {
        return
      }
      this.watcherWorking = true
      this.item[propertyName] = value
      this.$nextTick(() => {
        this.watcherWorking = false
      })
    },
    setWholesaler (address, owningComponent) {
      if (!address.org_wholesalers) {
        return
      }
      let wholesalers = address.org_wholesalers.trim().split(';').map(i => i.trim())

      owningComponent.item.wholesaler_1_id = null
      owningComponent.item.wholesaler_2_id = null
      owningComponent.item.wholesaler_3_id = null
      owningComponent.item.wholesaler_4_id = null
      owningComponent.item.wholesaler_5_id = null

      wholesalers.forEach((wholesaler, wholesalerIndex) => {
        let wholesalerSelectValues = this.$refs.wholesalerSelect.$children[0].$children[0].selectItems.filter(e => e.dwh_name == wholesaler)
        if (wholesalerSelectValues.length > 0) {
          let wholesalerSelectId = wholesalerSelectValues[0].id
          let wholesalerFieldIndex = wholesalerIndex + 1
          owningComponent.item[`wholesaler_${wholesalerFieldIndex}_id`] = wholesalerSelectId
        }
      })
    },
    isReadonly (line, q, child = false){
      let field = null
      let qStartMonth = null
      let qEndMonth = null
      let assinable = null
      let monthArray = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec']

      switch (q) {
        case 'q1':
          field = 'user_date_q1_input'
          qStartMonth = 1
          qEndMonth = 3
          assinable= 'q1_assignable'
          break
        case 'q2':
          field = 'user_date_q2_input'
          qStartMonth = 4
          qEndMonth = 6
          assinable= 'q2_assignable'
          break
        case 'q3':
          field = 'user_date_q3_input'
          qStartMonth = 7
          qEndMonth = 9
          assinable= 'q3_assignable'
          break
        case 'q4':
          field = 'user_date_q4_input'
          qStartMonth = 10
          qEndMonth = 12
          assinable= 'q4_assignable'
          break
        case 'yearly':
          field = 'user_date_yearly_input'
          break
      }

      if (q === 'yearly') {
        return !(!!line[field] && (line.delivery && line.delivery[q] ? !line.delivery[q].is_delivery_executed : true))
      }

      if(monthArray.includes(q)) {
        if(!line.apo_one) {
          return true
        }

        return !(line.apo_one.includes(q) && (line.delivery && line.delivery[q] ? !line.delivery[q].is_delivery_executed: true))
      }

      let validFromMonth = null
      if(line.valid_from_month) {
        validFromMonth = line.valid_from_month
      }
      let validToMonth = null
      if(line.valid_to_month) {
        validToMonth = line.valid_to_month
      }

      var readonlyVal = !(!!line[field] && (!validFromMonth || validFromMonth <= qEndMonth) && (validToMonth && validToMonth >= qStartMonth) &&
        (line.delivery && line.delivery[q] ? !line.delivery[q].is_delivery_executed : true))

      var sync = line.sync_quater_with_children
      if(sync && !readonlyVal && q !== 'yearly' && child === true) {
        if(line[assinable] === 1){
          return false
        } else {
          line['sync_quarter_'+q] = true
          return true
        }
      }
      return readonlyVal
    },
    setDateToChildren(line, i, type = 'from') {
      const self = this
      self.$nextTick(function (){
        if(!!line.allow_date_to_set_children) {
          if(line.children && Object.keys(line.children).length) {
            line.children.forEach(function (subLine) {
              if(type === 'from') {
                subLine.valid_from = line.valid_from
                subLine.valid_from_month = line.valid_from_month
                subLine.valid_from_year = line.valid_from_year
              } else {
                subLine.valid_to = line.valid_to
                subLine.valid_to_month = line.valid_to_month
                subLine.valid_to_year = line.valid_to_year
              }

              if (subLine.delivery && Object.keys(subLine.delivery).length) {
                Object.keys(subLine.delivery).forEach(function (p) {
                  if ((subLine.delivery[p] && subLine.delivery[p].quantity > 0) && self.isReadonly(subLine, p)) {
                    subLine.delivery[p].quantity = null
                  }
                })
              }

              self.setPrice(subLine, i)

              if(!!subLine.allow_date_to_set_children) {
                if(subLine.children && Object.keys(subLine.children).length) {
                  subLine.children.forEach(function (childLine) {
                    if(type === 'from') {
                      childLine.valid_from = subLine.valid_from
                      childLine.valid_from_month = subLine.valid_from_month
                      childLine.valid_from_year = subLine.valid_from_year
                    } else {
                      childLine.valid_to = subLine.valid_to
                      childLine.valid_to_month = subLine.valid_to_month
                      childLine.valid_to_year = subLine.valid_to_year
                    }

                    if (childLine.delivery && Object.keys(childLine.delivery).length) {
                      Object.keys(childLine.delivery).forEach(function (p) {
                        if ((childLine.delivery[p] && childLine.delivery[p].quantity > 0) && self.isReadonly(childLine, p)) {
                          childLine.delivery[p].quantity = null
                        }
                      })
                    }

                    self.setPrice(childLine, i)
                  })
                }
              }
            })
          }
        }
        if (line.delivery && Object.keys(line.delivery).length) {
          Object.keys(line.delivery).forEach(function (p) {
            if ((line.delivery[p] && line.delivery[p].quantity > 0) && self.isReadonly(line, p)) {
              line.delivery[p].quantity = null
            }
          })
        }
        self.setPrice(line, i)
      })
    },
    setDateChanged (line, type) {
      this.$nextTick(function () {
        if(!!line.allow_date_to_set_children) {
          if(line.children && Object.keys(line.children).length) {
            line.children.forEach(function (subLine) {
              if(type === 'from') {
                subLine.valid_from_changed = true
              } else {
                subLine.valid_to_changed = true
              }

              if(!!subLine.allow_date_to_set_children) {
                if(subLine.children && Object.keys(subLine.children).length) {
                  subLine.children.forEach(function (childLine) {
                    if(type === 'from') {
                      childLine.valid_from_changed = true
                    } else {
                      childLine.valid_to_changed = true
                    }
                  })
                }
              }
            })
          }
        }

        if (type === 'from') {
          line.valid_from_changed = true
        } else {
          line.valid_to_changed = true
        }
      })
    },
    setQuantityToParent(line, subLine, q, i) {
      const self = this
      this.$nextTick(function (){
        if (!!subLine.write_qty_from_child_to_parent) {
          if(line.delivery) {
            line.delivery[q].quantity = subLine.delivery ? subLine.delivery[q].quantity: null
            self.setPrice(line, i, q)
          }
        }
        self.setPrice(subLine, i, q)
      })
    },
    setPrice(itm, index = -1, field = null, fromload = 0) {
      const self = this

      //check convert quantity from month to quarter
      if(itm.transfer_monthly_quantity_to_quarter) {
        self.transferMonthlyQuantityToQuarter(itm, index, fromload)
      }

      const price = self.calculatePrice(itm, index)
      if(self.activeTab === 1 && price.maxQunatityError && field !== null) {
        self.$notify({
          title: this.$i18n.t('core.validation_error'),
          text: this.$i18n.t('sandoz.max_quantity_exceed'),
          type: 'error'
        })

        itm.delivery[field].quantity = itm.delivery[field].previous_quantity
        return false
      } else {
        itm.price = price.price
        itm.price_changes = price.price_changes
        self.$nextTick(function () {
          self.setSelectedItemPrice()
        })
      }
    },
    setDefaultPrice() {
      var _self = this
      _self.$nextTick(function (){
        if(_self.item.addresses) {
          _self.item.addresses.forEach(function (address) {
            if(address.address_type !== 'master') {
              return false
            }

            if(address.items.length) {
              address.items.forEach(function (item) {
                item.price = item.loaded_price ? Math.round(item.loaded_price): null
                if (item.children && Object.keys(item.children).length) {
                  item.children.forEach(function (subItem){
                    subItem.price = subItem.loaded_price ? Math.round(subItem.loaded_price): null

                    if (subItem.children && Object.keys(subItem.children).length) {
                      subItem.children.forEach(function (childItem) {
                        childItem.price = childItem.loaded_price ? Math.round(childItem.loaded_price): null
                      })
                    }
                  })
                }
              })
            }
          })
        }
      })
    },
    setQuantityToChild (itm, qtr, index = -1) {
      const self = this
      self.$nextTick(function (){
        if(itm.children && Object.keys(itm.children).length) {
          itm.children.forEach(function (subLine) {
            if (subLine.delivery && Object.keys(subLine.delivery).length) {
              if ((subLine.delivery[qtr] && subLine.child_qty)) {
                subLine.delivery[qtr].quantity = subLine.child_qty && itm.delivery[qtr].quantity !== null ? subLine.child_qty * itm.delivery[qtr].quantity : null
                self.$nextTick(function (){
                  self.setPrice(subLine, index, qtr)
                })
              }
            }

            if(subLine.children && Object.keys(subLine.children).length) {
              subLine.children.forEach(function (childLine) {
                if (childLine.delivery && Object.keys(childLine.delivery).length) {
                  if ((childLine.delivery[qtr] && childLine.child_qty)) {
                    childLine.delivery[qtr].quantity = childLine.child_qty && itm.delivery[qtr].quantity !== null ? childLine.child_qty * childLine.delivery[qtr].quantity : null
                    self.$nextTick(function () {
                      self.setPrice(childLine, index, qtr)
                    })
                  }
                }
              })
            }
          })
        }
      })
    },
    isGadgetOrBox (item){
      const self = this
      let is = false
      self.$nextTick(function (){
        if(item.children && Object.keys(item.children).length) {
          item.children.forEach(function (subLine) {
            if (subLine.box_or_gadget === 'box') {
              is = true
            }

            if(subLine.children && Object.keys(subLine.children).length) {
              subLine.children.forEach(function (childLine) {
                if (childLine.box_or_gadget === 'gadget') {
                  is = true
                }
              })
            }
          })
        }
      })
      return is
    },
    setBoxQuantity (item, qtr, boxOrGadget, index) {
      const self = this
      if(!['box', 'gadget'].includes(boxOrGadget)) {
        return
      }

      self.$nextTick(function (){
        let boxes = 0
        let gadgets = {yearly: 0, q1: 0, q2: 0, q3: 0, q4: 0}
        let itemBoxes = null
        let gadgetBoxes = null
        if(item.children && Object.keys(item.children).length) {
          item.children.forEach(function (subLine) {
            if (subLine.box_or_gadget === 'box' && subLine.delivery && Object.keys(subLine.delivery).length) {
              if ((subLine.delivery.yearly && subLine.delivery.yearly.quantity > 0)) {
                boxes = boxes + parseInt(subLine.delivery.yearly.quantity)
              }
            }

            if (subLine.box_or_gadget === 'gadget' && subLine.delivery && Object.keys(subLine.delivery).length) {
              Object.keys(subLine.delivery).forEach(function (p) {
                if ((subLine.delivery[p] && subLine.delivery[p].quantity > 0)) {
                  gadgets[p] = gadgets[p] + parseInt(subLine.delivery[p].quantity)
                }
              })
            }

            if(subLine.children && Object.keys(subLine.children).length) {
              subLine.children.forEach(function (childLine) {
                if (childLine.box_or_gadget === 'gadget' && childLine.delivery && Object.keys(childLine.delivery).length) {
                  Object.keys(childLine.delivery).forEach(function (p) {
                    if ((childLine.delivery[p] && childLine.delivery[p].quantity > 0)) {
                      gadgets[p] = gadgets[p] + parseInt(childLine.delivery[p].quantity)
                    }
                  })
                }

                if (childLine.box_or_gadget === 'box' && childLine.delivery && Object.keys(childLine.delivery).length) {
                  if ((childLine.delivery.yearly && childLine.delivery.yearly.quantity > 0)) {
                    boxes = boxes + parseInt(childLine.delivery.yearly.quantity)
                  }
                }
              })
            }
          })
        }

        if(boxOrGadget === 'box') {
          Object.keys(item.delivery).forEach(function (p) {
            if ((item.delivery[p])) {
              gadgetBoxes = gadgets[p] ? gadgets[p] / 20 : null
              gadgetBoxes = gadgetBoxes ? gadgetBoxes.toString().split(".")[0]: null

              if(boxes < gadgetBoxes) {
                itemBoxes = boxes ? parseInt(boxes): null
              } else {
                itemBoxes = gadgetBoxes ? parseInt(gadgetBoxes): null
              }

              item.delivery[p].quantity = itemBoxes > 0 ? itemBoxes : null
              self.setPrice(item, index, qtr)
            }
          })
        } else if(boxOrGadget === 'gadget') {
          gadgetBoxes = gadgets[qtr] ? gadgets[qtr] / 20 : null
          gadgetBoxes = gadgetBoxes ? gadgetBoxes.toString().split(".")[0]: null

          if(boxes < gadgetBoxes) {
            itemBoxes = boxes ? parseInt(boxes): null
          } else {
            itemBoxes = gadgetBoxes ? parseInt(gadgetBoxes): null
          }

          if(item.delivery[qtr]) {
            item.delivery[qtr].quantity = itemBoxes > 0 ? itemBoxes : null
            self.setPrice(item, index, qtr)
          }
        }
      })
    },
    calculatePrice(itm, index){
      const self = this
      let price = null
      let priceChanges = {}
      let capBasePrice = null
      let adjustablePrice = 'yes'
      const address = self.item.addresses[index === -1 ? self.addressIndex: index]
      if (itm.base_price && Object.keys(itm.base_price).length) {
        itm.base_price.forEach(function (p) {
          if (p.sales_line_price_category && Object.keys(p.sales_line_price_category).length) {
            if (p.sales_line_price_category.category_type === 'apo_one_sum_of_month') {
              if (p.price) {
                price = p.price
                capBasePrice = p.sales_line_price_category
                adjustablePrice = p.adjustable_price
              }
              priceChanges = p.price_changes
              return false
            }
          } else if(p.price_changes) {
            priceChanges = p.price_changes
            return false
          }
        })
      }

      address.cap_base_price = capBasePrice

      let quantity = null
      let yearlyQuantity = null
      if (itm.delivery && Object.keys(itm.delivery).length) {
        let monthArray = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec']
        Object.keys(itm.delivery).forEach(function (p) {
          if ((itm.delivery[p] && itm.delivery[p].quantity <= 0) || (!itm.delivery[p].is_delivery_executed && self.isReadonly(itm, p)) ||
            (itm.box_or_gadget && !self.isGadgetOrBox(itm)) ||
            (!monthArray.includes(p) && self.item.type === 'APO_ONE' && !!itm.transfer_monthly_quantity_to_quarter && !itm.apo_one_multiply_with_quantity)
          ) {
            return false
          }

          if(itm.delivery[p].quantity) {
            quantity = quantity + parseInt(itm.delivery[p].quantity)

            if(p === 'yearly') {
              yearlyQuantity = parseInt(itm.delivery[p].quantity)
            }
          }
        })
      }

      let maxQunatityError = false
      if((itm.max_quantity !== '' || itm.max_quantity !== null) && itm.max_quantity > 0) {
        if(parseInt(itm.max_quantity) < quantity) {
          maxQunatityError = true
        }
      }

      let newPrice = null
      if(priceChanges && priceChanges.price_changes && priceChanges.price_changes === 'any_price_allowed') {
        newPrice = itm.price * 1
      } else if(quantity && price) {
        if(itm.apo_one_multiply_with_quantity && yearlyQuantity > 0) {
          quantity = (parseInt(quantity) - yearlyQuantity) * yearlyQuantity
        }

        if(adjustablePrice === 'yes') {
          let months = ((itm.valid_to_month - itm.valid_from_month) + 1) / 12
          let durationPrice = (price * months) * yearlyQuantity

          let qPrice = price * (parseInt(quantity) - yearlyQuantity)
          newPrice = parseFloat((durationPrice + qPrice)).toFixed(2)
        } else {
          newPrice = parseFloat(price * quantity).toFixed(2)
        }
      }

      // Set for fix value items only
      if(itm.product_master_values && Object.keys(itm.product_master_values).length) {
        newPrice = Math.round(newPrice/10)*10
      }

      return {'price': newPrice ? Math.round(newPrice): null, 'price_changes': priceChanges?priceChanges:{}, 'maxQunatityError': maxQunatityError}
    },
    setContractDateToItems(fromload = 0) {
      const self = this
      const startDate = moment(self.item.contract_start)
      const expiredDate = moment(self.item.contract_expiration)

      let date = null
      let startMonth = null
      let startYear = null
      let endDate = null
      let endMonth = null
      let endYear = null
      if (startDate.isValid()) {
        date = startDate.date()
        startMonth = startDate.month() + 1
        startYear = startDate.year()
      }

      if (expiredDate.isValid()) {
        endDate = expiredDate.date()
        endMonth = expiredDate.month() + 1
        endYear = expiredDate.year()
      }

      startMonth = (startMonth < 10 ? '0' + startMonth : startMonth).toLocaleString()
      endMonth = (endMonth < 10 ? '0' + endMonth : endMonth).toLocaleString()

      if(self.item.addresses) {
        self.item.addresses.forEach(function (address, index) {
          if(address.address_type !== 'master') {
            return false
          }

          if(address.items) {
            address.items.forEach(function (line) {
              if(line.children) {
                line.children.forEach(function (subLine) {
                  if(subLine.children) {
                    subLine.children.forEach(function (childLine) {
                      childLine.valid_from_month = startYear != childLine.valid_from_year ? 1 : (childLine.valid_from_month != startMonth ? startMonth : childLine.valid_from_month)
                      childLine.valid_from_year = startYear != childLine.valid_from_year ? startYear : childLine.valid_from_year

                      childLine.valid_to_month = endYear != childLine.valid_to_year ? 12 : (childLine.valid_to_month != endMonth ? endMonth: childLine.valid_to_month)
                      childLine.valid_to_year = endYear != childLine.valid_to_year ? startYear : childLine.valid_to_year

                      self.$nextTick(function () {
                        if(fromload === 0) {
                          self.setPrice(childLine, index)
                        }
                      })
                    })
                  }

                  subLine.valid_from_month = startYear != subLine.valid_from_year ? 1 : (subLine.valid_from_month != startMonth ? startMonth : subLine.valid_from_month)
                  subLine.valid_from_year = startYear != subLine.valid_from_year ? startYear : subLine.valid_from_year

                  subLine.valid_to_month = endYear != subLine.valid_to_year ? 12 : (subLine.valid_to_month != endMonth ? endMonth: subLine.valid_to_month)
                  subLine.valid_to_year = endYear != subLine.valid_to_year ? startYear : subLine.valid_to_year

                  self.$nextTick(function () {
                    if(fromload === 0) {
                      self.setPrice(subLine, index)
                    }
                  })
                })
              }

              line.valid_from_month = startYear != line.valid_from_year ? 1 : (line.valid_from_month != startMonth ? startMonth : line.valid_from_month)
              line.valid_from_year = startYear != line.valid_from_year ? startYear : line.valid_from_year

              line.valid_to_month = endYear != line.valid_to_year ? 12 : (line.valid_to_month != endMonth ? endMonth : line.valid_to_month)
              line.valid_to_year = endYear != line.valid_to_year ? startYear : line.valid_to_year
              self.$nextTick(function () {
                if(fromload === 0) {
                  self.setPrice(line, index, null, fromload)
                }
              })
            })
          }
        })
      }
    },
    validatePrice(itm, index) {
      const self= this
      const basePrice = self.calculatePrice(itm, index)
      if(basePrice.price_changes && basePrice.price_changes.price_changes === 'no_changes_allowed') {
        this.$notify({
          title: this.$i18n.t('core.validation_error'),
          text: this.$i18n.t('sandoz.no_changes_allowed_error'),
          type: 'error'
        })
        itm.price = basePrice.price
        return false
      } else if(basePrice.price_changes && basePrice.price_changes.price_changes === 'minus_20_allowed') {
        const minPrice = parseFloat(((80 / 100) * basePrice.price).toFixed(0))
        if(itm.price < minPrice) {
          this.$notify({
            title: this.$i18n.t('core.validation_error'),
            text: this.$i18n.t('sandoz.minus_20_allowed_error'),
            type: 'error'
          })
          itm.price = minPrice
          return false
        }

        if(itm.price > basePrice.price) {
          this.$notify({
            title: this.$i18n.t('core.validation_error'),
            text: this.$i18n.t('sandoz.only_downward_error'),
            type: 'error'
          })
          itm.price = basePrice.price
          return false
        }
      } else if(basePrice.price_changes && basePrice.price_changes.price_changes === 'changes_allowed') {
        if(itm.price > basePrice.price) {
          this.$notify({
            title: this.$i18n.t('core.validation_error'),
            text: this.$i18n.t('sandoz.changes_allowed_error'),
            type: 'error'
          })
          itm.price = basePrice.price
          return false
        }
      } else if((basePrice.price_changes && basePrice.price_changes.price_changes === 'any_price_allowed') &&
        (itm.price === null || itm.price <= 0)
      ) {
        self.$notify({
          title: this.$i18n.t('core.validation_error'),
          text: this.$i18n.t('sandoz.any_price_allowed_error'),
          type: 'error'
        })
        itm.price = basePrice.price
        return false
      }
    },
    setSelectedItemPrice() {
      const self = this
      let price = 0
      let countAddressCapExceed = 0
      self.item.addresses.forEach(function (address, key) {
        let addressPrice = 0
        if (address.address_type === 'master') {
          address.items.forEach(function (item, key1) {
            let masterLinePrice = item.price > 0  ? item.price : 0
            price = parseFloat(price) + parseFloat(masterLinePrice)
            addressPrice = addressPrice + parseFloat(masterLinePrice)
            if(item.children && Object.keys(item.children).length) {
              let childrenPrice = self.getChildSelectedItemPrice(item)
              price = parseFloat(price) + parseFloat(childrenPrice)
              addressPrice = addressPrice + parseFloat(childrenPrice)
            }
          })

          if(address.cap_base_price) {
            let exceedCap = address.cap_base_price.cap

            if(exceedCap !== null && exceedCap < addressPrice) {
              address.cap_exceeded = true
              countAddressCapExceed = countAddressCapExceed + 1
            } else {
              address.cap_exceeded = false
            }
          }
        }
      })

      self.item.cap_exceeded = false
      if( countAddressCapExceed > 0) {
        self.item.cap_exceeded = true
      }
      self.item.marketing_activities = price
    },
    getChildSelectedItemPrice(item) {
      let childPrice = 0
      const self = this
      item.children.forEach(function (item, key1) {
        let masterLineChildPrice = item.price > 0 ? item.price : 0
        childPrice = childPrice + parseFloat(masterLineChildPrice)
        if(item.children && Object.keys(item.children).length) {
          let childrenPrice = self.getChildSelectedItemPrice(item)
          childPrice = parseFloat(childPrice) + parseFloat(childrenPrice)
        }
      })
      return childPrice
    },
    getProductPrice(itm) {
      const self = this
      let price = null
      let addressKey = null
      if( self.addressIndex === 'all') {
        let addrFound = false
        self.item.addresses.forEach(function (address, key) {
          if (address.address_type === 'master' && !addrFound) {
            addressKey = key
            addrFound = true
          }
        })
      }
      const address = self.item.addresses[self.addressIndex === 'all' ? addressKey : self.addressIndex]
      if (itm.base_price && Object.keys(itm.base_price).length) {
        itm.base_price.forEach(function (p) {
          if (p.sales_line_price_category && Object.keys(p.sales_line_price_category).length) {
            if (p.sales_line_price_category.category_type === 'apo_one_sum_of_month') {
              if (p.price) {
                price = p.price
              }
              return false
            }
          }
        })
      }
      return price
    },
    addItemsToAddresses(reset = true){
      const _self = this
      this.$nextTick(function (){
        if(_self.item.addresses) {
          _self.item.addresses.forEach(function (address, index) {
            if(address.address_type !== 'master') {
              return false
            }

            const isDraftOrNew = _self.$route.params.id === 'new' || (_self.item && (_self.item.status === 'Draft' || _self.item.status === 'Feedback'))
            if((reset && isDraftOrNew) || _self.$route.params.id === 'new') {
              _self.item.addresses[index].items = []
            }

            if (!address.items.length) {
              _self.addItemsToAddress (index, reset)
            }

            if(address.items.length && _self.$route.params.id !== 'new') {
              address.items.forEach(function (item) {
                const itemPrice = _self.addItemPrice(item, index)
                const price = _self.calculatePrice(item, index)

                item.item_price = itemPrice.price
                item.price = price.price
                item.price_changes = price.price_changes

                if (item.children && Object.keys(item.children).length) {
                  item.children.sort((a, b) => a.sort_order - b.sort_order).forEach(function (subItem){
                    const subItemPrice = _self.addItemPrice(subItem, index)
                    const subPrice = _self.calculatePrice(subItem, index)

                    subItem.item_price = subItemPrice.price
                    subItem.price = subPrice.price
                    subItem.price_changes = subPrice.price_changes

                    if (subItem.children && Object.keys(subItem.children).length) {
                      subItem.children.sort((a, b) => a.sort_order - b.sort_order).forEach(function (childItem) {
                        const childItemPrice = _self.addItemPrice(childItem, index)
                        const childPrice = _self.calculatePrice(childItem, index)

                        childItem.item_price = childItemPrice.price
                        childItem.price = childPrice.price
                        childItem.price_changes = childPrice.price_changes
                      })
                    }
                  })
                }
              })
            }
          })
        }
      })
    },
    addItemsToAddress (index) {
      const _self = this
      if (!this.item.type) {
        return
      }

      if(_self.addItemsToAddressFlag && _self.addItemsToAddressFlagIndex === index) {
        return
      }

      _self.addItemsToAddressFlag = true
      _self.addItemsToAddressFlagIndex = index

      let url = '/api/sandoz/apo-one/items?c_type='+_self.item.type+'&c_start='+_self.item.contract_start+'&c_end='+_self.item.contract_expiration+'&c_lang='+_self.item.language+'&c_year='+_self.item.contract_year
      axios
        .get(url)
        .then((response) => {
          response.data.forEach(function (item){
            const itemPrice = _self.addItemPrice(item, index)
            const price = _self.calculatePrice(item, index)

            item.item_price = itemPrice.price
            item.price = price.price
            item.price_changes = price.price_changes

            if (item.children && Object.keys(item.children).length) {
              item.children.sort((a, b) => a.sort_order - b.sort_order).forEach(function (subItem){
                const subItemPrice = _self.addItemPrice(subItem, index)
                const subPrice = _self.calculatePrice(subItem, index)

                subItem.item_price = subItemPrice.price
                subItem.price = subPrice.price
                subItem.price_changes = subPrice.price_changes

                if (subItem.children && Object.keys(subItem.children).length) {
                  subItem.children.sort((a, b) => a.sort_order - b.sort_order).forEach(function (childItem) {
                    const childItemPrice = _self.addItemPrice(childItem, index)
                    const childPrice = _self.calculatePrice(childItem, index)

                    childItem.item_price = childItemPrice.price
                    childItem.price = childPrice.price
                    childItem.price_changes = childPrice.price_changes
                  })
                }
              })
            }

            _self.item.addresses[index].items.push(item)
          })
          _self.addItemsToAddressFlag = false
          _self.addItemsToAddressFlagIndex = null
        })
    },
    addItemPrice(itm, index = -1){
      const self = this
      let itemPrice = null
      let priceChanges = {}
      const address = self.item.addresses[index === -1 ? self.addressIndex: index]
      if (itm.base_price && Object.keys(itm.base_price).length) {
        itm.base_price.forEach(function (p) {
          if (p.sales_line_price_category && Object.keys(p.sales_line_price_category).length) {
            if (p.sales_line_price_category.category_type === 'apo_one_sum_of_month') {
              if (p.price) {
                itemPrice = p.price
              }
              priceChanges = p.price_changes
              return false
            } else if(p.price_changes) {
              priceChanges = p.price_changes
              return false
            }
          } else if(p.price_changes) {
            priceChanges = p.price_changes
            return false
          }
        })
      }

      return {'price': itemPrice, 'price_changes': priceChanges?priceChanges:{}}
    },
    pdfContract() {
      this.$root.$loading.start()
      let delAddress = null
      this.item.addresses.forEach(function (address, key) {
        if (address.address_type === 'master' && delAddress === null) {
          delAddress = address
        }
      })

      let documentName = this.item.contract_no;
      if(this.item.contract_version !== null) {
        documentName += '-'+this.item.contract_version
      }else {
        documentName += '-1';
      }

      if(delAddress) {
        documentName += '-'+delAddress.company_name+' - '+delAddress.city
      }

      axios.post('/api/sandoz/generate-pdf2', {id:this.$route.params.id}, { responseType: 'arraybuffer' })
        .then((response) => {
          require('downloadjs')(
            response.data,
            documentName+'.pdf',
            'application/pdf'
          )
          this.$root.$loading.finish()
        }).catch((error) => {
        this.$root.$loading.finish()
        console.log(error)
      })
    },
    confirmWithUser() {
      var diffObject = diff(this.itemOld, this.item)
      delete diffObject['cap_exceeded']
      if((this.item.status === 'Draft' || this.item.status === 'Feedback') && diffObject && Object.keys(diffObject).length) {
        this.$bvModal.msgBoxConfirm('Some changes are not saved!', {
          title: 'Save changes',
          size: 'md',
          buttonSize: 'sm',
          okVariant: 'primary',
          okTitle: 'Save & Continue',
          cancelTitle: 'Cancel',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
          .then(value => {
            if(value) {
              const self = this
              self.downloadPDF = true
              self.save()
            }
          })
          .catch(err => {
            console.log('error', err)
            // An error occurred
          })
      } else {
        this.pdfContract()
      }
    },
    toggleAccordion (address, item) {
      const index = this.getAccordion(address, item)
      if (index !== -1) {
        this.accordionItems.splice(index, 1);
      } else {
        this.accordionItems.push(address + '' + item)
      }
    },
    getAccordion(address, item) {
      return this.accordionItems.indexOf(address + '' + item)
    },
    showDuplicateContract () {
      const routeData = this.$router.resolve({ path: '/sandoz/apo_one/contracts/' + this.showContract })
      window.open(routeData.href, '_blank')
    },
    addToWordFiles(evt) {
      var fileName = evt.target.value.replace(/^.*[\\/]/, '')
      var files = evt.target.files
      var file = files[0]

      if (!file) {
        return
      }

      if (file) {
        var reader = new window.FileReader()
        const self = this
        reader.onload = function (readerEvt) {
          let wordOb = {
            contract_id :self.item.id,
            user_id: self.user.id,
            user: self.user,
            file_name: {
              data: readerEvt.target.result,
              name: fileName
            }
          }
          self.item.word_files.push(wordOb);
          self.wordfile = null;
        }
        reader.readAsDataURL(file)
      }
    },
    addFile() {
      this.$refs.fileinput.$refs.input.click()
    },
    word (i) {
      if (i !== null) {
        const file = this.item.word_files[i]
        axios.post('/api/sandoz/contract_word_file/download', {
          'id': file.id
        }, {responseType: 'arraybuffer'})
          .then((response) => {
            require('downloadjs')(
              response.data,
              file.file_name.name,
              'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
            )
          }).catch((error) => {
          console.log(error)
        })
      }
    },
    transferMonthlyQuantityToQuarter(line, index, fromload = 0) {
      let monthArray = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec']
      let highestQuantityMonthValue = null
      let highestQuantity = 0
      const self = this
      monthArray.forEach(function (month, key) {
        if(!self.isReadonly(line, month)) {
          if(line.delivery && line.delivery[month]) {
            let quantity = parseInt(line.delivery[month].quantity)
            if(quantity && quantity > highestQuantity) {
              highestQuantity = quantity
              highestQuantityMonthValue = key + 1
            }
          }
        }
      })

      if(line.delivery) {
        line.delivery.q1.quantity = null
        line.delivery.q2.quantity = null
        line.delivery.q3.quantity = null
        line.delivery.q4.quantity = null

        let quarter = self.getQuaterFromMonth(highestQuantityMonthValue)
        let quarters = [1,2,3,4]
        if(quarter && quarter !== null) {
          line.delivery['q'+quarter].quantity = highestQuantity
          self.$nextTick(function (){
            if(fromload === 0) {
              self.setQuantityToChild(line, 'q'+quarter, index)
              quarters.forEach(function (qua, qkey) {
                if(qua !== quarter) {
                  self.setQuantityToChild(line, 'q'+qua, index)
                }
              })
            }
          })
        }
      }
    },
    getQuaterFromMonth(month) {
      if(month >= 1 && month <= 3) {
        return 1
      } else if(month > 3 && month <= 6) {
        return 2
      } else if(month > 6 && month <= 9) {
        return 3
      } else if(month > 9 && month <= 12) {
        return 4
      }
      return null
    },
    checkIndeterminantCheckbox() {
      if(this.item.addresses) {
        const self = this
        var determError = false;
        self.determErrorID = []
        self.item.addresses.forEach(function (address, index) {
          address.items.forEach(function (line, lineIndex) {
            if(line.contract_line_exist_attribute === 'indeterminate' && (line.exists_attribute_required || line.exist_value !== null) &&
            (line.delivery && line.delivery['yearly'].quantity !== null || line.delivery['jan'].quantity !== null || line.delivery['feb'].quantity !== null || line.delivery['mar'].quantity !== null || line.delivery['apr'].quantity !== null
            || line.delivery['may'].quantity !== null || line.delivery['jun'].quantity !== null || line.delivery['jul'].quantity !== null || line.delivery['aug'].quantity !== null || line.delivery['sep'].quantity !== null|| line.delivery['oct'].quantity !== null || line.delivery['nov'].quantity !== null || line.delivery['dec'].quantity !== null
            )) {
              determError = true;
              self.determErrorID.push(address.id+'-'+line.product.id)
            }
            if(line.children && Object.keys(line.children).length) {
              line.children.forEach(function (subLine, subLineIndex) {
                if(subLine.contract_line_exist_attribute === 'indeterminate' && (subLine.exists_attribute_required || subLine.exist_value !== null) &&
                (subLine.delivery && subLine.delivery['yearly'].quantity !== null || subLine.delivery['jan'].quantity !== null || subLine.delivery['feb'].quantity !== null || subLine.delivery['mar'].quantity !== null || subLine.delivery['apr'].quantity !== null
                || subLine.delivery['may'].quantity !== null || subLine.delivery['jun'].quantity !== null || subLine.delivery['jul'].quantity !== null || subLine.delivery['aug'].quantity !== null || subLine.delivery['sep'].quantity !== null|| subLine.delivery['oct'].quantity !== null || subLine.delivery['nov'].quantity !== null || subLine.delivery['dec'].quantity !== null
                )) {
                  determError = true;
                  self.determErrorID.push(address.id+'-'+subLine.product.id)
                }
                if(subLine.children && Object.keys(subLine.children).length) {
                  subLine.children.forEach(function (childLine, childLineIndex) {
                    if(childLine.contract_line_exist_attribute === 'indeterminate' && (childLine.exists_attribute_required || childLine.exist_value !== null) &&
                    (childLine.delivery && childLine.delivery['yearly'].quantity !== null || childLine.delivery['jan'].quantity !== null || childLine.delivery['feb'].quantity !== null || childLine.delivery['mar'].quantity !== null || childLine.delivery['apr'].quantity !== null
                      || childLine.delivery['may'].quantity !== null || childLine.delivery['jun'].quantity !== null || childLine.delivery['jul'].quantity !== null || childLine.delivery['aug'].quantity !== null || childLine.delivery['sep'].quantity !== null|| childLine.delivery['oct'].quantity !== null || childLine.delivery['nov'].quantity !== null || childLine.delivery['dec'].quantity !== null
                      )) {
                      determError = true;
                      self.determErrorID.push(address.id+'-'+childLine.product.id)
                    }
                  })
                }
              })
            }
          })
        })
        return determError
      }
    },
    checkLineChildren(line) {
      if(line.children && Object.keys(line.children).length)
      {
        return true
      }
      return false
    },
    linkValidate(link) {
      var linkUpdated = (link.indexOf('://') === -1) ? '//' + link : link;
      return linkUpdated
    },
      setPreviousQuantity(value, itm, field = null) {
      if(itm.delivery[field]) {
        itm.delivery[field].previous_quantity = value
      }
    }
  }
}
</script>

<style scoped>
td.exist_error {
  border: 1px solid red;
}
</style>
